import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";
import Header from "./Header";
import Swal from "sweetalert2";
import { ProductContext } from "../context/AppContext";
import { Button } from "antd";
import jsPDF from "jspdf";
import "bootstrap/dist/css/bootstrap.min.css";

const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

const childCountOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
];

const transportOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const primaryContactOptions = [
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
];

const singleParentOptions = [
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "guardian", label: "Guardian" }, // Add this line
];

const parentTypeOptions = [
  { value: "new", label: "New Parent" },
  { value: "existing", label: "Existing Parent(Sibiling already in school)" },
];

const referenceRoleOptions = [
  { value: "Ex student (alumni)", label: "Ex student (alumni)" },
  { value: "Present student (cousin)", label: "Present student (cousin)" },
  { value: "Ex staff", label: "Ex staff" },
  { value: "Present staff", label: "Present staff" },
  { value: "others", label: "Others" },
];
const referenceRoleLabelMap = {
  staff: "Staff",
  student: "Student",
  ex_student: "Ex-Student",
  ex_staff: "Ex-Staff",
  cousin: "Cousin",
  other: "Other",
};

const getReferenceRoleLabel = (role) => referenceRoleOptions[role] || "N/A";

const isSingleParentOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

function CreateEnquiry() {
  const navigate = useNavigate();
  const authtoken = localStorage.getItem("token");
  const schoolId = localStorage.getItem("schoolId");
  const [childCount, setChildCount] = useState(1);
  const [parentType, setParentType] = useState("new");
   const routes = all_routes;

  const [admissionNumber, setAdmissionNumber] = useState("");
  const [isSameDetails, setIsSameDetails] = useState(false);
  const [schoolLogoDataUrl, setSchoolLogoDataUrl] = useState(null);
  const [childrenData, setChildrenData] = useState([
    {
      full_name: "",
      dob: "",
      class: "",
      gender: "",
      showAllClasses: false,
      recommendedClass: "",
      recommendedClassIds: [],
      classMessage: "",
      matchesAgeCriteria: true,
      stream_id: "",
      father_name: "",
      mother_name: "",
      father_contact_no: "",
      mother_contact_no: "",
      primary_contact: "father",
      email: "",
      transport: "No",
      stoppage_id: "",
      contactReason: "",
      is_ref: false,
      ref_role: "",
      ref_admission_no: "",
      ref_year_of_leaving: "",
      ref_contact_no: "",
      ref_note: "",
      ref_name: "",
      ref_employee_code: "",
      ref_is_current: "",
      ref_relation: "",
      is_single_parent: false,
      single_parent: "",
      guardian_name: "",
      guardian_contact_no: "",
      guardian_relation: "",
      admission_num: "", // Add this line
      has_sibling: false, // Add this line
      created_by_student: true,

    },
  ]);
  const [hasFamilyMembers, setHasFamilyMembers] = useState(false);
  const [familyMemberCount, setFamilyMemberCount] = useState(1);
  const [familyMembersData, setFamilyMembersData] = useState([
    {
      ref_role: "",
      ref_name: "",
      ref_contact_no: "",
      ref_is_current: "",
      ref_year_of_leaving: "",
      ref_admission_no: "",
      ref_employee_code: "",
      ref_relation: "",
      ref_note: "",
    },
  ]);

  const familyMemberCountOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ];
  const [mobileVerificationData, setMobileVerificationData] = useState([
    {
      father_contact: { uuid: "", otpSent: false },
      mother_contact: { uuid: "", otpSent: false },
      guardian_contact: { uuid: "", otpSent: false }
    }
  ]);
  const [contactEditMode, setContactEditMode] = useState([
    { father: false, mother: false, guardian: false }
  ]);
  const [transportFees, setTransportFees] = useState([
    {
      one_way_monthly: 0,
      one_way_annual: 0,
      two_way_monthly: 0,
      two_way_annual: 0,
    }
  ]);
  const [schoolAutomation, setSchoolAutomation] = useState(null);

  const [mobileOTP, setMobileOTP] = useState([
    {
      father_contact: "",
      mother_contact: "",
      guardian_contact: ""
    }
  ]);
  const [existingEnquiryRecords, setExistingEnquiryRecords] = useState([null]);
  const [existingEnquiryModal, setExistingEnquiryModal] = useState({
    visible: false,
    enquiry: null,
    childIndex: null,
    contactType: null,
    contactLabel: "",
    contactNo: "",
    isRegistered: false,
    is_email_verified:false
  });

  console.log(existingEnquiryModal, "existingEnquiryModal")

  const [verificationStatus, setVerificationStatus] = useState([
    {
      email: { verified: false, otp: "", sent: false },
      father_contact: { verified: false },
      mother_contact: { verified: false },
      guardian_contact: { verified: false },
    },
  ]);

  const [sameDetailsOptions, setSameDetailsOptions] = useState([
    {
      sameFatherContact: true,
      sameMotherContact: true,
      sameEmail: true,
    },
  ]);
  const [sessionId, setSessionId] = useState("");
  const [sessions, setSessions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [stoppages, setStoppages] = useState([]);
  const [schoolRules, setSchoolRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [emailVerificationRequired, setEmailVerificationRequired] = useState(true);
  const [mobileVerificationRequired, setMobileVerificationRequired] = useState(true);
  const [sameContactConfirmed, setSameContactConfirmed] = useState({});
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const initialChildState = {
    full_name: "",
    dob: "",
    class: "",
    gender: "",
    showAllClasses: false,
    recommendedClass: "",
    recommendedClassIds: [],
    classMessage: "",
    matchesAgeCriteria: true,
    stream_id: "",
    father_name: "",
    mother_name: "",
    father_contact_no: "",
    mother_contact_no: "",
    primary_contact: "father",
    email: "",
    transport: "No",
    stoppage_id: "",
    contactReason: "",
    is_ref: false,
    ref_role: "",
    ref_admission_no: "",
    ref_year_of_leaving: "",
    ref_contact_no: "",
    ref_note: "",
    ref_name: "",
    ref_employee_code: "",
    is_single_parent: false,
    single_parent: "",
    guardian_name: "",
    guardian_contact_no: "",
    guardian_relation: "",
    admission_num: "",
    has_sibling: false,
    is_bonafide_required: null, // Add this line
  };
  const fetchImageAsDataURL = useCallback(async (imageUrl) => {
    if (!imageUrl) {
      return null;
    }
    try {
      const response = await fetch(imageUrl, { mode: "cors" });
      if (!response.ok) {
        throw new Error(`Failed to load image. Status: ${response.status}`);
      }
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("Image conversion failed."));
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Image fetch error:", error);
      return null;
    }
  }, []);
  const ENQUIRY_NOTES = [
    [
      "Parent/child details and documents are processed only by authorised school's team for admission elegibility.",
      "Unsuccessful enquiries are deleted after the selected academic session and admitted students’ records follow the documentation policy.",
    ],
    [
      "Optional: Helps us identify and verify your existing connection with the school and prioritise your application.",
      "Share another person’s contact details only with their permission.",
    ],
  ];

  // enquiry_text of the class selected for each child
  const getChildEnquiryTexts = () =>
    childrenData
      .map((child, index) => {
        const selectedClass = classes.find((cls) => cls.id === Number(child.class));
        return {
          index,
          childName: child.full_name,
          className: selectedClass?.Classes || "",
          text: selectedClass?.enquiry_text?.trim() || "",
        };
      })
      .filter((item) => item.text);

  useEffect(() => {
    const newVerificationStatus = [...verificationStatus];
    const newSameContactConfirmed = { ...sameContactConfirmed };
    let hasChanges = false;

    childrenData.forEach((child, index) => {
      if (
        !child.is_single_parent &&
        child.father_contact_no &&
        child.mother_contact_no &&
        child.father_contact_no === child.mother_contact_no
      ) {
        // If father's contact is verified and numbers are same, auto-verify mother's contact
        if (verificationStatus[index].father_contact.verified && !verificationStatus[index].mother_contact.verified) {
          newVerificationStatus[index].mother_contact.verified = true;
          hasChanges = true;
        }

        // If mother's contact is verified and numbers are same, auto-verify father's contact
        if (verificationStatus[index].mother_contact.verified && !verificationStatus[index].father_contact.verified) {
          newVerificationStatus[index].father_contact.verified = true;
          hasChanges = true;
        }

        if (!newSameContactConfirmed[index]) {
          newSameContactConfirmed[index] = true;
          hasChanges = true;
        }
      }
    });

    // Only update state if there are actual changes
    if (hasChanges) {
      setVerificationStatus(newVerificationStatus);
      setSameContactConfirmed(newSameContactConfirmed);
    }
  }, [childrenData]); // Remove verificationStatus from dependencies
  useEffect(() => {


    const fetchData = async () => {
      setLoading(true);
      try {
        const permissionsResponse = await fetch("https://api.mirai.healthcare/api/user/service-permission/student-enq", {
          headers: {
            accept: "application/json",
            "x-auth": authtoken,
            // schoolid: currentSchoolId,
          },
        });
        if (!permissionsResponse.ok) {
          throw new Error(`Permissions API failed with status ${permissionsResponse.status}.`);
        }
        const permissionsData = await permissionsResponse.json();
        if (permissionsData.success) {
          const services = permissionsData.message.returnService;
          setEmailVerificationRequired(
            services.find((s) => s.module_code === "STUDENT-ENQUIRY-EMAIL-VERIFY")?.active || false
          );
          setMobileVerificationRequired(
            services.find((s) => s.module_code === "STUDENT-ENQUIRY-MOB-VERIFY")?.active || false
          );
        } else {
          throw new Error("Permissions API returned success: false.");
        }

        const classesResponse = await fetch("https://api.mirai.healthcare/api/masters/classes", {
          headers: {
            "x-auth": authtoken,
            // schoolid: currentSchoolId,
          },
        });
        if (!classesResponse.ok) {
          throw new Error(`Classes API failed with status ${classesResponse.status}.`);
        }
        const classesData = await classesResponse.json();
        if (classesData.success) {
          setClasses(classesData.data || []);
          setChildrenData((prev) =>
            prev.map((child) => ({
              ...child,
              stream_id: classesData.data[0]?.streams[0]?.id || "",
            }))
          );
        } else {
          throw new Error("Classes API returned success: false.");
        }

        // Replace the sessions fetching and sessionId setting in the useEffect
        const sessionsResponse = await fetch("https://api.mirai.healthcare/api/masters/session", {
          headers: {
            "x-auth": authtoken,
            // schoolid: currentSchoolId,
          },
        });
        if (!sessionsResponse.ok) {
          throw new Error(`Sessions API failed with status ${sessionsResponse.status}.`);
        }
        const sessionsData = await sessionsResponse.json();
        if (sessionsData.success) {
          setSessions(sessionsData.data || []);

          // Priority: Use enq_session_id from schoolAutomation first, then current session
          let selectedSessionId = "";
          if (schoolAutomation?.enq_session_id) {
            selectedSessionId = schoolAutomation.enq_session_id.toString();
          } else {
            const currentSession = sessionsData.data.find((session) => session.Is_Current_Session);
            selectedSessionId = currentSession?.id || "";
          }

          setSessionId(selectedSessionId);
        } else {
          throw new Error("Sessions API returned success: false.");
        }

        let enqSessionId = null;
        try {
          const automationResponse = await fetch("https://api.mirai.healthcare/api/head/school-rule/school-automation", {
            headers: {
              accept: "application/json",
              "x-auth": authtoken,
              // schoolid: currentSchoolId,
            },
          });
          if (automationResponse.ok) {
            const automationData = await automationResponse.json();
            if (Array.isArray(automationData) && automationData.length) {
              setSchoolAutomation(automationData[0]);
              enqSessionId = automationData[0]?.enq_session_id ?? null;
              setSchoolLogoDataUrl(await fetchImageAsDataURL(automationData[0]?.schoolLogo));
            } else if (automationData && typeof automationData === "object") {
              setSchoolAutomation(automationData);
              enqSessionId = automationData.enq_session_id ?? null;
              setSchoolLogoDataUrl(await fetchImageAsDataURL(automationData.schoolLogo));
            } else {
              setSchoolAutomation(null);
              setSchoolLogoDataUrl(null);
            }
          } else {
            console.warn("School automation API failed with status", automationResponse.status);
            setSchoolAutomation(null);
            setSchoolLogoDataUrl(null);
          }
        } catch (automationError) {
          console.error("School automation fetch error:", automationError);
          setSchoolAutomation(null);
          setSchoolLogoDataUrl(null);
        }

        const stoppagesUrl = enqSessionId
          ? `https://api.mirai.healthcare/api/transport/route-stoppage?session_id=${enqSessionId}`
          : "https://api.mirai.healthcare/api/transport/route-stoppage";
        const stoppagesResponse = await fetch(stoppagesUrl, {
          headers: {
            "x-auth": authtoken,
            // schoolid: currentSchoolId,
          },
        });
        if (!stoppagesResponse.ok) {
          throw new Error(`Stoppages API failed with status ${stoppagesResponse.status}.`);
        }
        const stoppagesData = await stoppagesResponse.json();
        if (stoppagesData.success) {
          // Fees are per session inside route_fee; flatten the enquiry session's fee onto the stoppage
          const feeSessionId =
            enqSessionId ||
            (sessionsData.data || []).find((session) => session.Is_Current_Session)?.id;
          const normalizedStoppages = (stoppagesData.data || []).map((stop) => {
            const fees = Array.isArray(stop.route_fee) ? stop.route_fee : [];
            const sessionFee =
              fees.find((fee) => String(fee.session_id) === String(feeSessionId)) || fees[0] || {};
            return {
              ...stop,
              transport_fee_one_way: Number(sessionFee.transport_fee_one_way) || 0,
              transport_fee_two_way: Number(sessionFee.transport_fee_two_way) || 0,
            };
          });
          setStoppages(normalizedStoppages);
        } else {
          throw new Error("Stoppages API returned success: false.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedSchool, schoolId]);
  useEffect(() => {
    if (schoolAutomation?.enq_session_id) {
      setSessionId(schoolAutomation.enq_session_id.toString());
    }
  }, [schoolAutomation?.enq_session_id]);
  const formattedClasses = classes.map((cls) => ({
    value: cls.id,
    label: cls.Classes,
  }));

  const formattedStoppages = stoppages.map((stop) => ({
    value: stop.id,
    label: stop.stop_name,
  }));

  const calculateRecommendedClass = (dob) => {
    if (!dob) {
      return { id: "", ids: [], matchesAge: true };
    }

    const birthDate = new Date(dob);
    if (Number.isNaN(birthDate.getTime())) {
      return { id: "", ids: [], matchesAge: true };
    }

    // Get cutoff date from school automation, fallback to current date
    const cutoffDateStr = schoolAutomation?.enq_dob;
    const cutoffDate = cutoffDateStr ? new Date(cutoffDateStr) : new Date();

    console.log("Cutoff Date:", cutoffDate);
    console.log("Birth Date:", birthDate);

    // Calculate age in years at the cutoff date
    const ageInYears = Math.floor((cutoffDate.getTime() - birthDate.getTime()) / (365.25 * 24 * 60 * 60 * 1000))
    console.log("Age at cutoff:", ageInYears);

    const matchingClasses = classes.filter((cls) => {
      if (!cls.Age_Group) {
        return false;
      }

      const [minAgeRaw, maxAgeRaw] = cls.Age_Group.split("-").map((part) => part.trim());
      const minAge = parseFloat(minAgeRaw);
      const maxAge = parseFloat(maxAgeRaw);

      if (Number.isNaN(minAge) || Number.isNaN(maxAge)) {
        return false;
      }

      const tolerance = 0.01;

      // Check if age falls within the age group (inclusive with tolerance)
      return ageInYears >= minAge && ageInYears <= maxAge;
    });

    console.log("Matching classes:", matchingClasses.map(cls => ({
      class: cls.Classes,
      ageGroup: cls.Age_Group,
      id: cls.id
    })));

    return {
      id: matchingClasses[0]?.id || "",
      ids: matchingClasses.map((cls) => cls.id),
      matchesAge: matchingClasses.length > 0,
    };
  };
  const [showClassModal, setShowClassModal] = useState(false);
  const [selectedChildIndex, setSelectedChildIndex] = useState(0);
  const openClassModal = (index) => {
    setSelectedChildIndex(index);
    setShowClassModal(true);
  };

  const closeClassModal = () => {
    setShowClassModal(false);
    setSelectedChildIndex(0);
  };
  const calculateBonafideRequirement = (classId, classes, matchesAgeCriteria = true) => {
    if (!classId) {
      return null;
    }

    const selectedClass = classes.find((cls) => cls.id === Number(classId));
    if (!selectedClass) {
      return null;
    }

    const className = selectedClass.Classes || "";
    const fallsUnderNotice =
      /^(Nursery|LKG|UKG|I)$/i.test(className) ||
      /^(II|III|IV|V|VI|VII|VIII|IX|X|XI|XII)$/i.test(className);

    if (!matchesAgeCriteria && fallsUnderNotice) {
      return true;
    }

    return null;
  };
  const selectClassFromModal = (classId) => {
    const newChildrenData = [...childrenData];
    newChildrenData[selectedChildIndex].class = String(classId);

    // Calculate if the selected class matches age criteria
    const selectedClass = classes.find((cls) => cls.id === Number(classId));
    const { ids: recommendedClassIds } = calculateRecommendedClass(newChildrenData[selectedChildIndex].dob);
    const isAgeAppropriate = recommendedClassIds.includes(Number(classId));

    newChildrenData[selectedChildIndex].matchesAgeCriteria = isAgeAppropriate;
    newChildrenData[selectedChildIndex].classMessage = isAgeAppropriate
      ? ""
      : "Selected class doesn't match age criteria.";

    // Calculate and set bonafide requirement
    const isBonafideRequired = calculateBonafideRequirement(classId, classes, isAgeAppropriate);
    newChildrenData[selectedChildIndex].is_bonafide_required = isBonafideRequired;

    setChildrenData(newChildrenData);
    closeClassModal();
  };
  const fetchStudentDetails = async () => {
    if (!admissionNumber) {
      Swal.fire({
        icon: "error",
        title: "Invalid Admission Number",
        text: "Please enter a valid admission number.",
      });
      return;
    }

    setLoading(true);
    try {
      const currentSchoolId = selectedSchool?.school_id || selectedSchool?.value || localStorage.getItem("schoolId");
      const response = await fetch(`https://api.mirai.healthcare/api/student/admission?admission_num=${admissionNumber}`, {
        headers: {

          "x-auth": authtoken,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch student details: ${response.status}`);
      }
      const data = await response.json();
      if (data.success && data.message && data.message.length > 0) {
        const student = data.message[0];
        const studentDetails = {
          student_full_name: student.student_full_name || "N/A",
          father_full_name: student.father_full_name || "N/A",
          mother_full_name: student.mother_full_name || "N/A",
          father_mobile_no: student.father_mobile_no || "N/A",
          mother_mobile_no: student.mother_mobile_no || "N/A",
          father_email: student.father_email || student.mother_email || "N/A",
          class_name: student.cls_sec?.cls?.Classes || "N/A",
          section_name: student.cls_sec?.section?.section || "N/A",
          photo_url: student.upload_photo?.link || "",
        };
        setStudentDetails(studentDetails);
        setShowStudentModal(true);
      } else {
        throw new Error("No student found with the provided admission number.");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to fetch student details. Please check the admission number and try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const [otpSiblingSent, setotpSiblingSent] = useState(false);
  const [otpSiblingVerify, setotpSiblingVerify] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [siblingOtpMobile, setSiblingOtpMobile] = useState("");

  // Resend cooldown per OTP field, keyed like "sibling", "father_contact_0", "email_0"
  const OTP_RESEND_SECONDS = 30;
  const [otpCooldowns, setOtpCooldowns] = useState({});
  const hasActiveOtpCooldown = Object.values(otpCooldowns).some((secs) => secs > 0);
  useEffect(() => {
    if (!hasActiveOtpCooldown) return;
    const timer = setInterval(() => {
      setOtpCooldowns((prev) => {
        const next = {};
        Object.entries(prev).forEach(([key, secs]) => {
          if (secs > 1) next[key] = secs - 1;
        });
        return next;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [hasActiveOtpCooldown]);
  const startOtpCooldown = (key) =>
    setOtpCooldowns((prev) => ({ ...prev, [key]: OTP_RESEND_SECONDS }));
  const getOtpCooldown = (key) => otpCooldowns[key] || 0;
  const getOtpButtonLabel = (key, sent) => {
    const secs = getOtpCooldown(key);
    if (secs > 0) return `Resend in ${secs}s`;
    return sent ? "Resend OTP" : "Send OTP";
  };

  const handleSendOtp = async () => {
    if (!admissionNumber) {
      Swal.fire({
        icon: "error",
        title: "Missing Admission Number",
        text: "Please enter admission number first.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/student/otp-send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-auth": "YOUR_AUTH_TOKEN_HERE",
          },
          body: JSON.stringify({ admission_no: admissionNumber }),
        }
      );

      const data = await response.json();

      if (data.success) {
        const mobileNo = String(data.message?.StudentMedical?.mobile_no || "");
        const lastFour = mobileNo.slice(-4);
        setSiblingOtpMobile(lastFour);
        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: lastFour
            ? `OTP has been sent to the registered mobile number ending with ${lastFour}.`
            : "OTP has been sent successfully.",
        });
        setotpSiblingSent(true);
        startOtpCooldown("sibling");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to Send OTP",
          text: data.message || "Try again later.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otpSiblingVerify) {
      Swal.fire({
        icon: "error",
        title: "Missing OTP",
        text: "Please enter the OTP sent to your registered number.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/student/verify-otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-auth": "YOUR_AUTH_TOKEN_HERE",
          },
          body: JSON.stringify({
            admission_no: admissionNumber,
            otp: otpSiblingVerify,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "OTP Verified",
          text: "Verification successful! Fetching student details...",
        });
        setOtpVerified(true);

        // After OTP verified, call fetchStudentDetails()
        await fetchStudentDetails();
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid OTP",
          text: data.message || "Please check the OTP and try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmStudentDetails = () => {
    if (!studentDetails) return;

    const newChildrenData = childrenData.map((child) => ({
      ...child,
      father_name: studentDetails.father_full_name !== "N/A" ? studentDetails.father_full_name : child.father_name,
      mother_name: studentDetails.mother_full_name !== "N/A" ? studentDetails.mother_full_name : child.mother_name,
      father_contact_no: studentDetails.father_mobile_no !== "N/A" ? studentDetails.father_mobile_no : child.father_contact_no,
      mother_contact_no: studentDetails.mother_mobile_no !== "N/A" ? studentDetails.mother_mobile_no : child.mother_contact_no,
      email: studentDetails.father_email !== "N/A" ? studentDetails.father_email : child.email,
      contactReason:
        studentDetails.father_mobile_no === studentDetails.mother_mobile_no && studentDetails.father_mobile_no !== "N/A"
          ? "Same contact number used for existing student"
          : child.contactReason,
      ...(parentType === "existing" && { // Add this block
        admission_num: admissionNumber,
        has_sibling: true,
      }),
    }));

    setChildrenData(newChildrenData);
    setContactEditMode(newChildrenData.map(() => ({ father: false, mother: false, guardian: false })));
    setIsSameDetails(true);

    const newVerificationStatus = verificationStatus.map(() => ({
      email: {
        verified: studentDetails.father_email !== "N/A" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(studentDetails.father_email),
        otp: "",
        sent: false,
      },
      father_contact: {
        verified: studentDetails.father_mobile_no !== "N/A" && /^\d{10}$/.test(studentDetails.father_mobile_no),
      },
      mother_contact: {
        verified: studentDetails.mother_mobile_no !== "N/A" && /^\d{10}$/.test(studentDetails.mother_mobile_no),
      },
      guardian_contact: {
        verified: false,
      },
    }));
    setVerificationStatus(newVerificationStatus);

    const newSameDetailsOptions = sameDetailsOptions.map(() => ({
      sameFatherContact: true,
      sameMotherContact: true,
      sameEmail: true,
    }));
    setSameDetailsOptions(newSameDetailsOptions);

    const newSameContactConfirmed = {};
    newChildrenData.forEach((_, index) => {
      newSameContactConfirmed[index] = studentDetails.father_mobile_no === studentDetails.mother_mobile_no && studentDetails.father_mobile_no !== "N/A";
    });
    setSameContactConfirmed(newSameContactConfirmed);

    setShowStudentModal(false);
    Swal.fire({
      icon: "success",
      title: "Details Autofilled",
      text: "Parent details have been autofilled from the provided admission number.",
    });
  };

  const handleChildCountChange = (selectedOption) => {
    const count = selectedOption ? selectedOption.value : 1;
    setChildCount(count);
    const newChildrenData = Array(count)
      .fill()
      .map((_, index) =>
        index < childrenData.length
          ? childrenData[index]
          : {
            full_name: "",
            dob: "",
            class: "",
            gender: "",
            showAllClasses: false,
            recommendedClass: "",
            classMessage: "",
            matchesAgeCriteria: true,
            stream_id: classes[0]?.streams[0]?.id || "",
            father_name: isSameDetails ? childrenData[0]?.father_name : "",
            mother_name: isSameDetails ? childrenData[0]?.mother_name : "",
            father_contact_no: isSameDetails ? childrenData[0]?.father_contact_no : "",
            mother_contact_no: isSameDetails ? childrenData[0]?.mother_contact_no : "",
            primary_contact: isSameDetails ? childrenData[0]?.primary_contact : "father",
            email: isSameDetails ? childrenData[0]?.email : "",
            transport: isSameDetails ? childrenData[0]?.transport : "No",
            stoppage_id: isSameDetails ? childrenData[0]?.stoppage_id : "",
            contactReason: isSameDetails ? childrenData[0]?.contactReason : "",
            is_ref: false,
            ref_role: "",
            ref_admission_no: "",
            ref_year_of_leaving: "",
            ref_contact_no: "",
            ref_note: "",
            ref_name: "",
            ref_employee_code: "",
            is_single_parent: false,
            single_parent: "",
            guardian_name: "",
            guardian_contact_no: "",
            guardian_relation: "",
            admission_num: isSameDetails ? childrenData[0]?.admission_num : "", // Add this line
            has_sibling: isSameDetails ? childrenData[0]?.has_sibling : false, // Add this line
            recommendedClassIds: isSameDetails
              ? [...(childrenData[0]?.recommendedClassIds || [])]
              : [],
          }
      );
    setChildrenData(newChildrenData);
    const newMobileVerificationData = Array(count)
      .fill()
      .map((_, index) =>
        index < mobileVerificationData.length
          ? mobileVerificationData[index]
          : {
            father_contact: { uuid: "", otpSent: false },
            mother_contact: { uuid: "", otpSent: false },
            guardian_contact: { uuid: "", otpSent: false }
          }
      );
    setMobileVerificationData(newMobileVerificationData);

    const newMobileOTP = Array(count)
      .fill()
      .map((_, index) =>
        index < mobileOTP.length
          ? mobileOTP[index]
          : {
            father_contact: "",
            mother_contact: "",
            guardian_contact: ""
          }
      );
    setMobileOTP(newMobileOTP);
    const newTransportFees = Array(count)
      .fill()
      .map((_, index) =>
        index < transportFees.length
          ? transportFees[index]
          : {
            one_way_monthly: 0,
            one_way_annual: 0,
            two_way_monthly: 0,
            two_way_annual: 0,
          }
      );
    setTransportFees(newTransportFees);
    const newContactEditMode = Array(count)
      .fill()
      .map((_, index) =>
        index < contactEditMode.length
          ? { ...contactEditMode[index] }
          : { father: false, mother: false, guardian: false }
      );
    setContactEditMode(newContactEditMode);
    setVerificationStatus((prev) =>
      Array(count)
        .fill()
        .map((_, index) =>
          index < prev.length
            ? prev[index]
            : {
              email: {
                verified: isSameDetails && prev[0]?.email.verified && sameDetailsOptions[index]?.sameEmail ? true : false,
                otp: "",
                sent: false,
              },
              father_contact: {
                verified: isSameDetails && prev[0]?.father_contact.verified && sameDetailsOptions[index]?.sameFatherContact ? true : false,
              },
              mother_contact: {
                verified: isSameDetails && prev[0]?.mother_contact.verified && sameDetailsOptions[index]?.sameMotherContact ? true : false,
              },
              guardian_contact: { verified: false },
            }
        )
    );
    setSameDetailsOptions((prev) =>
      Array(count)
        .fill()
        .map((_, index) =>
          index < prev.length
            ? prev[index]
            : {
              sameFatherContact: true,
              sameMotherContact: true,
              sameEmail: true,
            }
        )
    );
    setSameContactConfirmed((prev) => ({
      ...prev,
      ...Array(count)
        .fill()
        .reduce((acc, _, i) => (i < childrenData.length ? acc : { ...acc, [i]: false }), {}),
    }));
    setExistingEnquiryRecords((prev) =>
      Array(count)
        .fill(null)
        .map((_, index) => (index < prev.length ? prev[index] : null))
    );
  };

  const handleFamilyMemberCountChange = (selectedOption) => {
    const count = selectedOption ? selectedOption.value : 1;
    setFamilyMemberCount(count);
    const newFamilyMembersData = Array(count)
      .fill()
      .map((_, index) =>
        index < familyMembersData.length
          ? familyMembersData[index]
          : {
            ref_role: "",
            ref_name: "",
            ref_contact_no: "",
            ref_is_current: "",
            ref_year_of_leaving: "",
            ref_admission_no: "",
            ref_employee_code: "",
            ref_relation: "",
            ref_note: "",
          }
      );
    setFamilyMembersData(newFamilyMembersData);
  };

  const handleFamilyMemberChange = (index, field, value) => {
    const newFamilyMembersData = [...familyMembersData];
    const currentMember = { ...newFamilyMembersData[index] };

    if (field === "ref_role") {
      currentMember.ref_role = value;

      const hideCurrentStatusRoles = ["ex_student", "ex_staff", "cousin", "other"];
      const exRoles = ["ex_student", "ex_staff"];

      if (exRoles.includes(value)) {
        currentMember.ref_is_current = false;
      } else if (hideCurrentStatusRoles.includes(value)) {
        currentMember.ref_is_current = "";
        currentMember.ref_year_of_leaving = "";
      } else {
        currentMember.ref_is_current = "";
        currentMember.ref_year_of_leaving = "";
      }

      if (!["student", "ex_student"].includes(value)) {
        currentMember.ref_admission_no = "";
      }

      if (!["staff", "ex_staff"].includes(value)) {
        currentMember.ref_employee_code = "";
      }

      if (["cousin", "other"].includes(value)) {
        currentMember.ref_relation = "";
      }
    } else {
      currentMember[field] = value;

      if (field === "ref_is_current" && value !== false) {
        currentMember.ref_year_of_leaving = "";
      }
    }

    newFamilyMembersData[index] = currentMember;
    setFamilyMembersData(newFamilyMembersData);
  };

  const handleSameDetailsChange = (checked) => {
    setIsSameDetails(checked);
    if (checked && childrenData.length > 1) {
      const newChildrenData = childrenData.map((child, index) =>
        index === 0
          ? child
          : {
            ...child,
            father_name: childrenData[0].father_name,
            mother_name: childrenData[0].mother_name,
            father_contact_no: childrenData[0].father_contact_no,
            mother_contact_no: childrenData[0].mother_contact_no,
            primary_contact: childrenData[0].primary_contact,
            email: childrenData[0].email,
            transport: childrenData[0].transport,
            stoppage_id: childrenData[0].stoppage_id,
            contactReason: childrenData[0].contactReason,
            is_ref: childrenData[0].is_ref,
            ref_role: childrenData[0].ref_role,
            ref_admission_no: childrenData[0].ref_admission_no,
            ref_year_of_leaving: childrenData[0].ref_year_of_leaving,
            ref_contact_no: childrenData[0].ref_contact_no,
            ref_note: childrenData[0].ref_note,
            ref_name: childrenData[0].ref_name,
            ref_employee_code: childrenData[0].ref_employee_code,
            is_single_parent: childrenData[0].is_single_parent,
            single_parent: childrenData[0].single_parent,
            guardian_name: childrenData[0].guardian_name,
            guardian_contact_no: childrenData[0].guardian_contact_no,
            admission_num: childrenData[0].admission_num, // Add this line
            has_sibling: childrenData[0].has_sibling, // Add this line
          }
      );
      setChildrenData(newChildrenData);
      const newVerificationStatus = verificationStatus.map((status, index) =>
        index === 0
          ? status
          : {
            ...status,
            email: { ...status.email, verified: verificationStatus[0].email.verified && sameDetailsOptions[index].sameEmail },
            father_contact: { verified: verificationStatus[0].father_contact.verified && sameDetailsOptions[index].sameFatherContact },
            mother_contact: { verified: verificationStatus[0].mother_contact.verified && sameDetailsOptions[index].sameMotherContact },
            guardian_contact: { verified: verificationStatus[0].guardian_contact.verified },
          }
      );
      setVerificationStatus(newVerificationStatus);
      const newSameContactConfirmed = { ...sameContactConfirmed };
      for (let i = 1; i < childrenData.length; i++) {
        newSameContactConfirmed[i] = childrenData[0].father_contact_no === childrenData[0].mother_contact_no;
      }
      setSameContactConfirmed(newSameContactConfirmed);
      setContactEditMode((prev) =>
        prev.map((mode, index) =>
          index === 0 ? mode : { father: false, mother: false, guardian: false }
        )
      );
    } else if (!checked) {
      const newVerificationStatus = verificationStatus.map((status, index) =>
        index === 0
          ? status
          : {
            email: { verified: false, otp: "", sent: false },
            father_contact: { verified: false },
            mother_contact: { verified: false },
            guardian_contact: { verified: false },
          }
      );
      setVerificationStatus(newVerificationStatus);
      setSameContactConfirmed({});
      setContactEditMode((prev) =>
        prev.map(() => ({ father: false, mother: false, guardian: false }))
      );
    }
  };

  const handleContactEdit = (childIndex, contactKey) => {
    const editKeyMap = {
      father_contact: "father",
      mother_contact: "mother",
      guardian_contact: "guardian",
    };

    setContactEditMode((prev) => {
      const updated = [...prev];
      const current = { father: false, mother: false, guardian: false, ...(updated[childIndex] || {}) };
      current[editKeyMap[contactKey]] = true;
      updated[childIndex] = current;
      return updated;
    });

    const newVerificationStatus = [...verificationStatus];
    if (newVerificationStatus[childIndex]?.[contactKey]) {
      newVerificationStatus[childIndex][contactKey] = {
        ...newVerificationStatus[childIndex][contactKey],
        verified: false,
      };
    }
    setVerificationStatus(newVerificationStatus);

    const newMobileVerificationData = [...mobileVerificationData];
    if (newMobileVerificationData[childIndex]) {
      newMobileVerificationData[childIndex] = {
        ...newMobileVerificationData[childIndex],
        [contactKey]: { uuid: "", otpSent: false },
      };
    }
    setMobileVerificationData(newMobileVerificationData);

    const newMobileOTP = [...mobileOTP];
    if (newMobileOTP[childIndex]) {
      newMobileOTP[childIndex] = {
        ...newMobileOTP[childIndex],
        [contactKey]: "",
      };
    }
    setMobileOTP(newMobileOTP);

    setSameContactConfirmed((prev) => ({ ...prev, [childIndex]: false }));
  };

  const handleSameDetailsOptionChange = (index, field, checked) => {
    const newSameDetailsOptions = [...sameDetailsOptions];
    newSameDetailsOptions[index] = { ...newSameDetailsOptions[index], [field]: checked };
    setSameDetailsOptions(newSameDetailsOptions);

    if (!checked) {
      const newVerificationStatus = [...verificationStatus];
      const newMobileVerificationData = [...mobileVerificationData];
      const newMobileOTP = [...mobileOTP];

      if (field === "sameFatherContact") {
        newVerificationStatus[index].father_contact.verified = false;
        newMobileVerificationData[index].father_contact = { uuid: "", otpSent: false };
        newMobileOTP[index].father_contact = "";
      } else if (field === "sameMotherContact") {
        newVerificationStatus[index].mother_contact.verified = false;
        newMobileVerificationData[index].mother_contact = { uuid: "", otpSent: false };
        newMobileOTP[index].mother_contact = "";
      } else if (field === "sameEmail") {
        newVerificationStatus[index].email = { verified: false, otp: "", sent: false };
      }
      setVerificationStatus(newVerificationStatus);
      setMobileVerificationData(newMobileVerificationData);
      setMobileOTP(newMobileOTP);

      const newChildrenData = [...childrenData];
      if (field === "sameFatherContact") {
        newChildrenData[index].father_contact_no = childrenData[0].father_contact_no;
        newVerificationStatus[index].father_contact.verified = verificationStatus[0].father_contact.verified;
        newChildrenData[index].contactReason = "";
      } else if (field === "sameMotherContact") {
        newChildrenData[index].mother_contact_no = childrenData[0].mother_contact_no;
        newVerificationStatus[index].mother_contact.verified = verificationStatus[0].mother_contact.verified;
        newChildrenData[index].contactReason = "";
      } else if (field === "sameEmail") {
        newChildrenData[index].email = "";
      }
      setChildrenData(newChildrenData);
      setVerificationStatus(newVerificationStatus);
      setSameContactConfirmed((prev) => ({ ...prev, [index]: false }));
      setContactEditMode((prev) => {
        const updated = [...prev];
        const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
        if (field === "sameFatherContact") {
          current.father = false;
        }
        if (field === "sameMotherContact") {
          current.mother = false;
        }
        updated[index] = current;
        return updated;
      });
    } else {
      const newChildrenData = [...childrenData];
      const newVerificationStatus = [...verificationStatus];
      if (field === "sameFatherContact") {
        newChildrenData[index].father_contact_no = childrenData[0].father_contact_no;
        newChildrenData[index].contactReason = childrenData[0].contactReason;
        newVerificationStatus[index].father_contact.verified = verificationStatus[0].father_contact.verified;
      } else if (field === "sameMotherContact") {
        newChildrenData[index].mother_contact_no = childrenData[0].mother_contact_no;
        newChildrenData[index].contactReason = childrenData[0].contactReason;
        newVerificationStatus[index].mother_contact.verified = verificationStatus[0].mother_contact.verified;
      } else if (field === "sameEmail") {
        newChildrenData[index].email = childrenData[0].email;
        newVerificationStatus[index].email = {
          ...newVerificationStatus[index].email,
          verified: verificationStatus[0].email.verified,
        };
      }
      setChildrenData(newChildrenData);
      setVerificationStatus(newVerificationStatus);
      if ((field === "sameFatherContact" || field === "sameMotherContact") && childrenData[0].father_contact_no === childrenData[0].mother_contact_no) {
        setSameContactConfirmed((prev) => ({ ...prev, [index]: true }));
      }
      setContactEditMode((prev) => {
        const updated = [...prev];
        const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
        if (field === "sameFatherContact") {
          current.father = false;
        }
        if (field === "sameMotherContact") {
          current.mother = false;
        }
        updated[index] = current;
        return updated;
      });
    }
  };

  const handleChildChange = (index, field, value) => {
  const editModeEntry = contactEditMode[index] || { father: false, mother: false, guardian: false };

  if (
    (field === "father_contact_no" && verificationStatus[index].father_contact.verified && !editModeEntry.father) ||
    (field === "mother_contact_no" && verificationStatus[index].mother_contact.verified && !editModeEntry.mother) ||
    (field === "guardian_contact_no" && verificationStatus[index].guardian_contact.verified && !editModeEntry.guardian)
  ) {
    Swal.fire({
      icon: "info",
      title: "Edit Required",
      text: "Please use the Edit button to modify a verified contact number.",
    });
    return;
  }

  const newChildrenData = [...childrenData];
  newChildrenData[index] = { ...newChildrenData[index], [field]: value };
  
  if (
    (field === "father_contact_no" || field === "mother_contact_no") &&
    !childrenData.is_single_parent
  ) {
    const newChildrenData = [...childrenData];
    newChildrenData[index] = { ...newChildrenData[index], [field]: value };

    const fatherContact = field === "father_contact_no" ? value : newChildrenData[index].father_contact_no;
    const motherContact = field === "mother_contact_no" ? value : newChildrenData[index].mother_contact_no;

    if (fatherContact && motherContact && fatherContact === motherContact) {
      const newVerificationStatus = [...verificationStatus];
      const newSameContactConfirmed = { ...sameContactConfirmed };
      const updatedEditMode = [...contactEditMode];
      const modeEntry = { father: false, mother: false, guardian: false, ...(updatedEditMode[index] || {}) };

      // If one is verified, verify the other automatically
      if (verificationStatus[index].father_contact.verified && !verificationStatus[index].mother_contact.verified) {
        newVerificationStatus[index].mother_contact.verified = true;
        modeEntry.mother = false;
      } else if (verificationStatus[index].mother_contact.verified && !verificationStatus[index].father_contact.verified) {
        newVerificationStatus[index].father_contact.verified = true;
        modeEntry.father = false;
      }

      newSameContactConfirmed[index] = true;

      setVerificationStatus(newVerificationStatus);
      setSameContactConfirmed(newSameContactConfirmed);
      updatedEditMode[index] = modeEntry;
      setContactEditMode(updatedEditMode);
    }
  }
  
  // Reset verification status if contact number changes
  if (field === "father_contact_no" && verificationStatus[index].father_contact.verified) {
    const newVerificationStatus = [...verificationStatus];
    newVerificationStatus[index].father_contact.verified = false;
    setVerificationStatus(newVerificationStatus);

    const newMobileVerificationData = [...mobileVerificationData];
    newMobileVerificationData[index].father_contact = { uuid: "", otpSent: false };
    setMobileVerificationData(newMobileVerificationData);
  }

  if (field === "mother_contact_no" && verificationStatus[index].mother_contact.verified) {
    const newVerificationStatus = [...verificationStatus];
    newVerificationStatus[index].mother_contact.verified = false;
    setVerificationStatus(newVerificationStatus);

    const newMobileVerificationData = [...mobileVerificationData];
    newMobileVerificationData[index].mother_contact = { uuid: "", otpSent: false };
    setMobileVerificationData(newMobileVerificationData);
  }

  if (field === "guardian_contact_no" && verificationStatus[index].guardian_contact.verified) {
    const newVerificationStatus = [...verificationStatus];
    newVerificationStatus[index].guardian_contact.verified = false;
    setVerificationStatus(newVerificationStatus);

    const newMobileVerificationData = [...mobileVerificationData];
    newMobileVerificationData[index].guardian_contact = { uuid: "", otpSent: false };
    setMobileVerificationData(newMobileVerificationData);
  }

  if (field === "dob") {
    const { id: recommendedClass, ids: recommendedClassIds, matchesAge } = calculateRecommendedClass(value);
    newChildrenData[index].recommendedClass = recommendedClass;
    newChildrenData[index].recommendedClassIds = recommendedClassIds;
    newChildrenData[index].class = recommendedClass || "";
    newChildrenData[index].classMessage = matchesAge ? "" : "Selected class doesn't match age criteria.";
    newChildrenData[index].matchesAgeCriteria = matchesAge;
    newChildrenData[index].is_bonafide_required = calculateBonafideRequirement(
      recommendedClass || "",
      classes,
      matchesAge
    );
  }

  if (field === "class") {
    const selectedClass = classes.find((cls) => cls.id === Number(value));

    const { ids: recommendedClassIds } = calculateRecommendedClass(newChildrenData[index].dob);
    const isAgeAppropriate = recommendedClassIds.includes(Number(value));

    newChildrenData[index].matchesAgeCriteria = isAgeAppropriate;
    newChildrenData[index].classMessage = isAgeAppropriate
      ? ""
      : "Selected class doesn't match age criteria.";

    newChildrenData[index].is_bonafide_required = calculateBonafideRequirement(
      value,
      classes,
      isAgeAppropriate
    );

    if (selectedClass) {
      const availableStreams = selectedClass.streams || [];

      if (availableStreams.length === 0) {
        newChildrenData[index].stream_id = "";
      } else if (availableStreams.length === 1 && availableStreams[0].name === "Default") {
        newChildrenData[index].stream_id = availableStreams[0].id;
      } else {
        const matchingStream = availableStreams.find(
          (stream) => Number(stream.id) === Number(newChildrenData[index].stream_id)
        );

        if (!matchingStream || matchingStream.name === "Default") {
          newChildrenData[index].stream_id = "";
        }
      }
    }
  }

  if (field === "is_single_parent" && !value) {
    newChildrenData[index].single_parent = "";
    newChildrenData[index].guardian_name = "";
    newChildrenData[index].guardian_contact_no = "";
    newChildrenData[index].father_name = "";
    newChildrenData[index].father_contact_no = "";
    newChildrenData[index].mother_name = "";
    newChildrenData[index].mother_contact_no = "";
  }

  if (
    isSameDetails &&
    index === 0 &&
    [
      "father_name",
      "mother_name",
      "father_contact_no",
      "mother_contact_no",
      "primary_contact",
      "email",
      "transport",
      "stoppage_id",
      "contactReason",
      "is_ref",
      "ref_role",
      "ref_admission_no",
      "ref_year_of_leaving",
      "ref_contact_no",
      "ref_note",
      "ref_name",
      "ref_employee_code",
      "is_single_parent",
      "single_parent",
      "guardian_name",
      "guardian_contact_no",
      "admission_num", // Add this line
      "has_sibling", // Add this line
    ].includes(field)
  ) {
    newChildrenData.forEach((child, i) => {
      if (i !== 0) {
        if (
          (field === "father_contact_no" && sameDetailsOptions[i].sameFatherContact) ||
          (field === "mother_contact_no" && sameDetailsOptions[i].sameMotherContact) ||
          (field === "email" && sameDetailsOptions[i].sameEmail) ||
          ([
            "father_name",
            "mother_name",
            "primary_contact",
            "transport",
            "stoppage_id",
            "contactReason",
            "is_ref",
            "ref_role",
            "ref_admission_no",
            "ref_year_of_leaving",
            "ref_contact_no",
            "ref_note",
            "ref_name",
            "ref_employee_code",
            "is_single_parent",
            "single_parent",
            "guardian_name",
            "guardian_contact_no",
            "admission_num", // Add this line
            "has_sibling", // Add this line
          ].includes(field))
        ) {
          newChildrenData[i][field] = value;
        }
      }
    });
    if (field === "father_contact_no" || field === "mother_contact_no" || field === "guardian_contact_no") {
      const newSameContactConfirmed = { ...sameContactConfirmed };
      for (let i = 1; i < childrenData.length; i++) {
        if (sameDetailsOptions[i].sameFatherContact && sameDetailsOptions[i].sameMotherContact) {
          newSameContactConfirmed[i] = newChildrenData[0].father_contact_no === newChildrenData[0].mother_contact_no;
        }
      }
      setSameContactConfirmed(newSameContactConfirmed);
    }
    if (field === "father_contact_no" || field === "mother_contact_no" || field === "email" || field === "guardian_contact_no") {
      const newVerificationStatus = [...verificationStatus];
      if (field === "father_contact_no") {
        newVerificationStatus[index].father_contact.verified = false;
        setContactEditMode((prev) => {
          const updated = [...prev];
          const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
          current.father = true;
          updated[index] = current;
          return updated;
        });
      }
      if (field === "mother_contact_no") {
        newVerificationStatus[index].mother_contact.verified = false;
        setContactEditMode((prev) => {
          const updated = [...prev];
          const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
          current.mother = true;
          updated[index] = current;
          return updated;
        });
      }
      if (field === "guardian_contact_no") {
        newVerificationStatus[index].guardian_contact.verified = false;
        setContactEditMode((prev) => {
          const updated = [...prev];
          const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
          current.guardian = true;
          updated[index] = current;
          return updated;
        });
      }
      if (field === "email") {
        newVerificationStatus[index].email.verified = false;
        newVerificationStatus[index].email.otp = "";
        newVerificationStatus[index].email.sent = false;
      }
      setVerificationStatus(newVerificationStatus);
    }
  }

  if (["father_contact_no", "mother_contact_no", "guardian_contact_no", "primary_contact"].includes(field)) {
    setExistingEnquiryRecords((prev) => {
      const updated = [...prev];
      if (index < updated.length) {
        updated[index] = null;
      }
      return updated;
    });
  }

  setChildrenData(newChildrenData);
  if (field === "transport" || field === "stoppage_id") {
    const newChildrenData = [...childrenData];
    newChildrenData[index] = { ...newChildrenData[index], [field]: value };

    // Calculate transport fees when transport is enabled and stoppage is selected
    if (value === "Yes" || (field === "stoppage_id" && newChildrenData[index].transport === "Yes")) {
      calculateTransportFees(index, newChildrenData[index].stoppage_id);
    } else {
      // Reset fees if transport is disabled
      const newTransportFees = [...transportFees];
      newTransportFees[index] = {
        one_way_monthly: 0,
        one_way_annual: 0,
        two_way_monthly: 0,
        two_way_annual: 0,
      };
      setTransportFees(newTransportFees);
    }

    setChildrenData(newChildrenData);
    return;
  }
  if (field === "primary_contact") {
    lookupExistingEnquiry(index, value, newChildrenData);
  }

  if (field === "single_parent") {
    lookupExistingEnquiry(index, value, newChildrenData);
  }

  if (["father_contact_no", "mother_contact_no", "guardian_contact_no"].includes(field)) {
    const contactRoleFromField = {
      father_contact_no: "father",
      mother_contact_no: "mother",
      guardian_contact_no: "guardian",
    };
    const role = contactRoleFromField[field];
    const snapshotChild = newChildrenData[index];
    const selectedPrimary = snapshotChild.is_single_parent ? snapshotChild.single_parent : snapshotChild.primary_contact;
    const contactNo = snapshotChild[field];
    const alreadyMatched = existingEnquiryRecords[index]?.contactNo === contactNo;

    if (
      role &&
      snapshotChild.is_single_parent &&
      selectedPrimary === role &&
      contactNo &&
      /^\d{10}$/.test(contactNo) &&
      !alreadyMatched
    ) {
      lookupExistingEnquiry(index, role, newChildrenData, { bypassContactVerification: true });
    }
  }
};
  const calculateTransportFees = (index, stoppageId) => {
    if (!stoppageId) return;

    const selectedStoppage = stoppages.find(stop => stop.id === Number(stoppageId));

    if (selectedStoppage) {
      const oneWayMonthly = selectedStoppage.transport_fee_one_way || 0;
      const twoWayMonthly = selectedStoppage.transport_fee_two_way || 0;

      const newTransportFees = [...transportFees];
      newTransportFees[index] = {
        one_way_monthly: oneWayMonthly,
        one_way_annual: oneWayMonthly * 12,
        two_way_monthly: twoWayMonthly,
        two_way_annual: twoWayMonthly * 12,
      };
      setTransportFees(newTransportFees);
    }
  };
  const sendMobileOTP = async (index, contactType) => {
    if (!mobileVerificationRequired) {
      const newVerificationStatus = [...verificationStatus];
      newVerificationStatus[index][contactType].verified = true;
      setVerificationStatus(newVerificationStatus);
      return;
    }

    const contactNo =
      contactType === "father_contact" ? childrenData[index].father_contact_no :
        contactType === "mother_contact" ? childrenData[index].mother_contact_no :
          childrenData[index].guardian_contact_no;

    if (!contactNo || !/^\d{10}$/.test(contactNo)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Contact Number",
        text: `Please enter a valid 10-digit ${contactType === "father_contact" ? "father's" : contactType === "mother_contact" ? "mother's" : "guardian's"} contact number.`,
      });
      return;
    }

    // Check if same contact number is already verified for other children
    if (isSameDetails && index !== 0) {
      const sameContactOption =
        contactType === "father_contact" ? sameDetailsOptions[index].sameFatherContact :
          contactType === "mother_contact" ? sameDetailsOptions[index].sameMotherContact :
            false;

      if (sameContactOption && verificationStatus[0][contactType].verified) {
        const newVerificationStatus = [...verificationStatus];
        newVerificationStatus[index][contactType].verified = true;
        setVerificationStatus(newVerificationStatus);
        Swal.fire({
          icon: "success",
          title: "Contact Verified",
          text: `${contactType === "father_contact" ? "Father's" : contactType === "mother_contact" ? "Mother's" : "Guardian's"} contact number has been verified (same as Child 1).`,
        });
        return;
      }
    }

    setLoading(true);
    try {
      const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");
      const response = await fetch("https://api.mirai.healthcare/api/sms/airtel/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth": authtoken || "",
          // "schoolid": currentSchoolId,
        },
        body: JSON.stringify({
          mobile_no: contactNo
        }),
      });

      const data = await response.json();
      console.log("Send OTP Response:", data); // Debug log

      if (response.ok && data.success) {
        // Extract UUID from nested response
        const uuid = data.message?.data?.uuid;

        if (!uuid) {
          throw new Error("UUID not received from OTP service");
        }

        const newMobileVerificationData = [...mobileVerificationData];
        newMobileVerificationData[index] = {
          ...newMobileVerificationData[index],
          [contactType]: {
            uuid: uuid,
            otpSent: true
          }
        };
        setMobileVerificationData(newMobileVerificationData);
        startOtpCooldown(`${contactType}_${index}`);

        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: `An OTP has been sent to ${contactNo}. Please check your messages.`,
        });
      } else {
        throw new Error(data.message || data.message?.message || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Send OTP Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };
  const verifyMobileOTP = async (index, contactType) => {
    if (!mobileVerificationRequired) {
      const newVerificationStatus = [...verificationStatus];
      newVerificationStatus[index][contactType].verified = true;
      setVerificationStatus(newVerificationStatus);
      return;
    }

    const contactNo =
      contactType === "father_contact" ? childrenData[index].father_contact_no :
        contactType === "mother_contact" ? childrenData[index].mother_contact_no :
          childrenData[index].guardian_contact_no;

    const otp = mobileOTP[index][contactType];
    const uuid = mobileVerificationData[index][contactType].uuid;

    console.log("Verification Data:", { // Debug log
      contactNo,
      otp,
      uuid,
      contactType,
      mobileVerificationData: mobileVerificationData[index]
    });

    if (!otp || !/^\d{4,6}$/.test(otp)) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: "Please enter a valid OTP received on your mobile.",
      });
      return;
    }

    if (!uuid) {
      Swal.fire({
        icon: "error",
        title: "Verification Error",
        text: "OTP session not found. Please request a new OTP.",
      });
      return;
    }

    setLoading(true);
    try {
      const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");
      const response = await fetch("https://api.mirai.healthcare/api/sms/airtel/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth": authtoken || "",
          // "schoolid": currentSchoolId,
        },
        body: JSON.stringify({
          otp: parseInt(otp, 10),
          uuid: uuid
        }),
      });

      const data = await response.json();
      console.log("Verify OTP Response:", data); // Debug log

      if (response.ok && data.success) {
        const newVerificationStatus = [...verificationStatus];
        newVerificationStatus[index][contactType].verified = true;
        setVerificationStatus(newVerificationStatus);

        const editKeyMap = {
          father_contact: "father",
          mother_contact: "mother",
          guardian_contact: "guardian",
        };
        setContactEditMode((prev) => {
          const updated = [...prev];
          const current = { father: false, mother: false, guardian: false, ...(updated[index] || {}) };
          current[editKeyMap[contactType]] = false;
          updated[index] = current;
          return updated;
        });

        // Disable the contact number field after verification
        const newChildrenData = [...childrenData];
        if (contactType === "father_contact") {
          newChildrenData[index].father_contact_no = contactNo; // Lock the value
        } else if (contactType === "mother_contact") {
          newChildrenData[index].mother_contact_no = contactNo; // Lock the value
        } else if (contactType === "guardian_contact") {
          newChildrenData[index].guardian_contact_no = contactNo; // Lock the value
        }
        setChildrenData(newChildrenData);

        // Clear OTP field after successful verification
        const newMobileOTP = [...mobileOTP];
        newMobileOTP[index] = {
          ...newMobileOTP[index],
          [contactType]: ""
        };
        setMobileOTP(newMobileOTP);

        Swal.fire({
          icon: "success",
          title: "Contact Verified",
          text: `${contactType === "father_contact" ? "Father's" : contactType === "mother_contact" ? "Mother's" : "Guardian's"} contact number has been successfully verified.`,
        });

        const contactRoleMap = {
          father_contact: "father",
          mother_contact: "mother",
          guardian_contact: "guardian",
        };
        const updatedChild = newChildrenData[index];
        const referenceRole = updatedChild.is_single_parent
          ? updatedChild.single_parent
          : updatedChild.primary_contact;
        const contactRole = contactRoleMap[contactType];
        if (contactRole && referenceRole === contactRole) {
          lookupExistingEnquiry(index, contactRole, newChildrenData);
        }
      } else {
        throw new Error(data.message || data.message?.message || "Invalid OTP. Please check the OTP and try again.");
      }
    } catch (error) {
      console.error("Verify OTP Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };
  const sendEmailOTP = async (index) => {
    if (!emailVerificationRequired) {
      const newVerificationStatus = [...verificationStatus];
      newVerificationStatus[index].email.verified = true;
      setVerificationStatus(newVerificationStatus);
      return;
    }

    const email = childrenData[index].email;
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address (e.g., example@domain.com).",
      });
      return;
    }

    if (isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail && verificationStatus[0].email.verified) {
      const newVerificationStatus = [...verificationStatus];
      newVerificationStatus[index].email.verified = true;
      setVerificationStatus(newVerificationStatus);
      return;
    }

    setLoading(true);
    try {
      const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");
      const response = await fetch("https://api.mirai.healthcare/api/enquiry/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth": authtoken,
          // "schoolid": currentSchoolId,
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        const newVerificationStatus = [...verificationStatus];
        newVerificationStatus[index].email.sent = true;
        setVerificationStatus(newVerificationStatus);
        startOtpCooldown(`email_${index}`);
        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: `An OTP has been sent to ${email}. Check your inbox or spam folder.`,
        });
      } else {
        throw new Error(data.message || "Failed to send OTP. Please try again or contact support.");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const verifyEmailOTP = async (index) => {
    if (!emailVerificationRequired) {
      const newVerificationStatus = [...verificationStatus];
      newVerificationStatus[index].email.verified = true;
      setVerificationStatus(newVerificationStatus);
      return;
    }

    const email = childrenData[index].email;
    const otp = verificationStatus[index].email.otp;
    if (!otp || !/^\d{6}$/.test(otp)) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: "Please enter a valid 6-digit OTP received in your email.",
      });
      return;
    }

    setLoading(true);
    try {
      const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");
      const response = await fetch("https://api.mirai.healthcare/api/enquiry/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json, text/plain, */*",
          "Accept-Language": "en-GB,en;q=0.9,en-US;q=0.8",
          "x-auth": authtoken,
          // "schoolid": currentSchoolId,
        },
        body: JSON.stringify({ email, otp: parseInt(otp, 10) }),
      });

      const data = await response.json();
      if (response.ok) {
        const newVerificationStatus = [...verificationStatus];
        newVerificationStatus[index].email.verified = true;
        setVerificationStatus(newVerificationStatus);
        Swal.fire({
          icon: "success",
          title: "Email Verified",
          text: "Email has been successfully verified.",
        });
      } else {
        throw new Error(data.message || "Invalid OTP. Please check the OTP and try again.");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const formatEnquiryDob = (value) => {
    if (!value) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const parts = value.split("-");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return value;
  };

  const autoFillChildFromEnquiry = (index, enquiry, contactType, contactNo) => {
    setChildrenData((prev) => {
      const updated = [...prev];
      const child = { ...updated[index] };

      if (enquiry.student_full_name || enquiry.student_name) {
        child.full_name = enquiry.student_full_name || enquiry.student_name;
      }

      const formattedDob = formatEnquiryDob(enquiry.dob);
      if (formattedDob) {
        child.dob = formattedDob;
      }

      if (enquiry.gender) {
        child.gender = enquiry.gender;
      }

      if (enquiry.class_data?.id) {
        child.class = String(enquiry.class_data.id);
      }

      if (enquiry.stream_id) {
        child.stream_id = enquiry.stream_id;
      }

      child.father_name = enquiry.fathername || child.father_name;
      child.mother_name = enquiry.mothername || child.mother_name;

      if (enquiry.contactno) {
        child.father_contact_no = enquiry.contactno;
      }

      if (enquiry.mother_contact_no) {
        child.mother_contact_no = enquiry.mother_contact_no;
      }

      if (enquiry.guardian_mobile_no) {
        child.guardian_contact_no = enquiry.guardian_mobile_no;
      }

      if (enquiry.guardian_name) {
        child.guardian_name = enquiry.guardian_name;
      }

      if (enquiry.guardian_relation) {
        child.guardian_relation = enquiry.guardian_relation;
      }

      if (typeof enquiry.is_single_parent === "boolean") {
        child.is_single_parent = enquiry.is_single_parent;
      }

      if (enquiry.single_parent) {
        child.single_parent = enquiry.single_parent;
      }

      if (enquiry.emailid) {
        child.email = enquiry.emailid;
      }

      if (typeof enquiry.is_transport === "boolean") {
        child.transport = enquiry.is_transport ? "Yes" : "No";
      }
      if (typeof enquiry.created_by_student === "boolean") {
        child.transport = enquiry.created_by_student ? "Yes" : "No";
      }

      if (enquiry.stoppage_id) {
        child.stoppage_id = enquiry.stoppage_id;
      }

      if (Array.isArray(enquiry.consent) && enquiry.consent.length > 0) {
        child.contactReason = enquiry.consent[0];
      }

      if (child.dob) {
        const { id: recommendedClass, ids: recommendedClassIds, matchesAge } = calculateRecommendedClass(child.dob);
        child.recommendedClass = recommendedClass;
        child.recommendedClassIds = recommendedClassIds;
        child.matchesAgeCriteria = matchesAge;
        child.classMessage = matchesAge ? "" : "Selected class doesn't match age criteria.";
        if (!child.class && recommendedClass) {
          child.class = String(recommendedClass);
        }
      }

      if (child.class) {
        const bonafideFromApi = enquiry.is_bonafied_require;
        if (typeof bonafideFromApi === "boolean") {
          child.is_bonafide_required = bonafideFromApi;
        } else if (typeof bonafideFromApi === "number") {
          child.is_bonafide_required = bonafideFromApi === 1;
        } else if (typeof bonafideFromApi === "string") {
          const normalized = bonafideFromApi.toLowerCase();
          if (normalized === "true" || normalized === "1") {
            child.is_bonafide_required = true;
          } else if (normalized === "false" || normalized === "0") {
            child.is_bonafide_required = false;
          } else {
            child.is_bonafide_required = calculateBonafideRequirement(
              child.class,
              classes,
              child.matchesAgeCriteria ?? true
            );
          }
        } else {
          child.is_bonafide_required = calculateBonafideRequirement(
            child.class,
            classes,
            child.matchesAgeCriteria ?? true
          );
        }
      }

      updated[index] = child;
      return updated;
    });
    setContactEditMode((prev) => {
      const updated = [...prev];
      updated[index] = { father: false, mother: false, guardian: false };
      return updated;
    });

    setVerificationStatus((prev) => {
      const updated = [...prev];
      if (updated[index]) {
        const status = { ...updated[index] };
        status.father_contact = { verified: contactType === "father_contact" };
        status.mother_contact = { verified: contactType === "mother_contact" };
        status.guardian_contact = { verified: contactType === "guardian_contact" };
        status.email = { ...(status.email || { verified: true, otp: "", sent: true }) };
        updated[index] = status;
      }
      return updated;
    });

    setMobileVerificationData((prev) => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = {
          father_contact: { uuid: "", otpSent: false },
          mother_contact: { uuid: "", otpSent: false },
          guardian_contact: { uuid: "", otpSent: false },
        };
      }
      return updated;
    });

    setMobileOTP((prev) => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = { father_contact: "", mother_contact: "", guardian_contact: "" };
      }
      return updated;
    });

    setSameContactConfirmed((prev) => ({
      ...prev,
      [index]: enquiry.contactno && enquiry.mother_contact_no && enquiry.contactno === enquiry.mother_contact_no,
    }));

    setExistingEnquiryRecords((prev) => {
      const updated = [...prev];
      updated[index] = {
        id: enquiry.id,
        isRegistered: enquiry.is_registered,
        contactNo,
      };
      return updated;
    });
  };

  const closeExistingEnquiryModal = () => {
    setExistingEnquiryModal({
      visible: false,
      enquiry: null,
      childIndex: null,
      contactType: null,
      contactLabel: "",
      contactNo: "",
      isRegistered: false,
    });
  };

  const handleExistingEnquiryApply = () => {
    if (!existingEnquiryModal.enquiry || existingEnquiryModal.childIndex === null || existingEnquiryModal.isRegistered) {
      closeExistingEnquiryModal();
      return;
    }

    autoFillChildFromEnquiry(
      existingEnquiryModal.childIndex,
      existingEnquiryModal.enquiry,
      existingEnquiryModal.contactType,
      existingEnquiryModal.contactNo
    );

    Swal.fire({
      icon: "success",
      title: "Details Applied",
      text: "Existing enquiry details have been applied. Please review and update if required before submitting.",
    });

    closeExistingEnquiryModal();
  };

  const lookupExistingEnquiry = async (childIndex, primaryContactValue, updatedChildrenData, options = {}) => {
    const { bypassContactVerification = false } = options;
    if (!primaryContactValue) {
      return;
    }

    const emailVerified = emailVerificationRequired
      ? verificationStatus[childIndex]?.email?.verified
      : true;

    // if (!emailVerified) {
    //   Swal.fire({
    //     icon: "info",
    //     title: "Verify Email",
    //     text: "Please verify the email address before checking for existing enquiries.",
    //   });
    //   return;
    // }

    const contactFieldMap = {
      father: "father_contact_no",
      mother: "mother_contact_no",
      guardian: "guardian_contact_no",
    };

    const contactVerificationMap = {
      father: "father_contact",
      mother: "mother_contact",
      guardian: "guardian_contact",
    };

    const contactField = contactFieldMap[primaryContactValue];
    const contactVerificationKey = contactVerificationMap[primaryContactValue];

    if (!contactField || !contactVerificationKey) {
      return;
    }

    const snapshotChildren = updatedChildrenData || childrenData;
    const contactNo = snapshotChildren?.[childIndex]?.[contactField];

    if (!contactNo || !/^\d{10}$/.test(contactNo)) {
      Swal.fire({
        icon: "info",
        title: "Contact Required",
        text: "Please enter a valid 10-digit contact number before checking for existing enquiries.",
      });
      return;
    }

    const contactVerified = mobileVerificationRequired && !bypassContactVerification
      ? verificationStatus[childIndex]?.[contactVerificationKey]?.verified
      : true;

    if (!contactVerified) {
      Swal.fire({
        icon: "info",
        title: "Verify Contact",
        text: "Please verify the selected primary contact number before fetching existing enquiry details.",
      });
      return;
    }

    const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");



    setLoading(true);
    try {
      const url = new URL("https://api.mirai.healthcare/api/enquiry/by-number");
      url.searchParams.set("mobile_no", contactNo);

      const headers = {
        accept: "application/json",
        "Content-Type": "application/json",
        "x-auth": authtoken,
        // "schoolid": currentSchoolId,
      };

      if (authtoken) {
        headers["x-auth"] = authtoken;
      }

      const response = await fetch(url.toString(), {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch enquiry details (status ${response.status})`);
      }

      const data = await response.json();

      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        const enquiry = data.data[0];

        const isRegistered = !!enquiry.is_registered;

        if (isRegistered) {
          setExistingEnquiryRecords((prev) => {
            const updated = [...prev];
            updated[childIndex] = {
              id: enquiry.id,
              isRegistered: true,
              contactNo,
            };
            return updated;
          });
        }

        setExistingEnquiryModal({
          visible: true,
          enquiry,
          childIndex,
          contactType: contactVerificationKey,
          contactLabel: primaryContactValue,
          contactNo,
          isRegistered,
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "No Enquiry Found",
          text: `No enquiry was found for ${contactNo}.`,
        });
        setExistingEnquiryRecords((prev) => {
          const updated = [...prev];
          if (childIndex < updated.length) {
            updated[childIndex] = null;
          }
          return updated;
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to fetch existing enquiry details.",
      });
    } finally {
      setLoading(false);
    }
  };



  const validateForm = () => {
    const newErrors = {};
    let hasVerificationErrors = false;

    const resolvedSchoolId =
      selectedSchool?.value ||
      selectedSchool?.school_id ||
      schoolId;


    for (let index = 0; index < childrenData.length; index++) {
      const child = childrenData[index];
      // Validate Full Name
      if (!child.full_name || child.full_name.trim() === "") {
        newErrors[`child_${index}_full_name`] = "Full name is required. Please enter the child's full name as per the birth certificate.";
      }
      // Validate Date of Birth
      if (!child.dob) {
        newErrors[`child_${index}_dob`] = "Date of birth is required. Please select a valid date.";
      }
      // Validate Gender
      if (!child.gender) {
        newErrors[`child_${index}_gender`] = "Gender is required. Please select Male or Female.";
      }
      // Validate Class
      if (!child.class) {
        newErrors[`child_${index}_class`] = "Class is required. Please select a class or check the DOB.";
      }
      // Validate Stream only when the selected class has multiple stream choices
      if (child.class) {
        const selectedClass = classes.find((cls) => cls.id === Number(child.class));
        const availableStreams = selectedClass?.streams || [];
        const requiresExplicitStreamSelection =
          availableStreams.length > 0 &&
          !(availableStreams.length === 1 && availableStreams[0]?.name === "Default");

        if (requiresExplicitStreamSelection && !child.stream_id) {
          newErrors[`child_${index}_stream_id`] = "Stream is required. Please select a stream for the chosen class.";
        }
      }
      // Validate Parent Details
      if (child.is_single_parent) {
        if (!child.single_parent) {
          newErrors[`child_${index}_single_parent`] = "Please select a parent type for single parent.";
        }
        if (child.single_parent === "father") {
          if (!child.father_name || child.father_name.trim() === "") {
            newErrors[`child_${index}_father_name`] = "Father’s name is required.";
          }
          if (!child.father_contact_no || !/^\d{10}$/.test(child.father_contact_no)) {
            newErrors[`child_${index}_father_contact_no`] = "Valid 10-digit father's contact number is required.";
          }
        } else if (child.single_parent === "mother") {
          if (!child.mother_name || child.mother_name.trim() === "") {
            newErrors[`child_${index}_mother_name`] = "Mother’s name is required.";
          }
          if (!child.mother_contact_no || !/^\d{10}$/.test(child.mother_contact_no)) {
            newErrors[`child_${index}_mother_contact_no`] = "Valid 10-digit mother's contact number is required.";
          }
        } else if (child.single_parent === "guardian") {
          if (!child.guardian_name || child.guardian_name.trim() === "") {
            newErrors[`child_${index}_guardian_name`] = "Guardian's name is required.";
          }
          if (!child.guardian_contact_no || !/^\d{10}$/.test(child.guardian_contact_no)) {
            newErrors[`child_${index}_guardian_contact_no`] = "Valid 10-digit guardian's contact number is required.";
          }
          if (!child.guardian_relation || child.guardian_relation.trim() === "") {
            newErrors[`child_${index}_guardian_relation`] = "Guardian's relation is required.";
          }
        }
      } else {
        if (!child.father_name || child.father_name.trim() === "") {
          newErrors[`child_${index}_father_name`] = "Father’s name is required.";
        }
        if (!child.mother_name || child.mother_name.trim() === "") {
          newErrors[`child_${index}_mother_name`] = "Mother’s name is required.";
        }
        if (!child.father_contact_no || !/^\d{10}$/.test(child.father_contact_no)) {
          newErrors[`child_${index}_father_contact_no`] = "Valid 10-digit father's contact number is required.";
        }
        if (!child.mother_contact_no || !/^\d{10}$/.test(child.mother_contact_no)) {
          newErrors[`child_${index}_mother_contact_no`] = "Valid 10-digit mother's contact number is required.";
        }
      }
      // Existing validations for other fields
      if (!child.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(child.email)) {
        newErrors[`child_${index}_email`] = "Valid email is required.";
      }
      if (!child.transport) {
        newErrors[`child_${index}_transport`] = "Please specify if transport is required.";
      }

      if (child.transport === "Yes" && !child.stoppage_id) {
        newErrors[`child_${index}_stoppage_id`] = "Stoppage is required if transport is selected.";
      }
      if (!child.primary_contact) {
        newErrors[`child_${index}_primary_contact`] = "Primary contact is required.";
      }
      if (
        emailVerificationRequired &&
        !verificationStatus[index].email.verified &&
        !(isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail && verificationStatus[0].email.verified)
      ) {
        newErrors[`child_${index}_email_verification`] = "Email must be verified.";
        hasVerificationErrors = true;
      }
      if (
        mobileVerificationRequired &&
        !child.is_single_parent &&
        !verificationStatus[index].father_contact.verified &&
        !(isSameDetails && index !== 0 && sameDetailsOptions[index].sameFatherContact && verificationStatus[0].father_contact.verified)
      ) {
        newErrors[`child_${index}_father_contact_verification`] = "Father’s contact number must be verified.";
        hasVerificationErrors = true;
      }
      if (
        mobileVerificationRequired &&
        !child.is_single_parent &&
        !verificationStatus[index].mother_contact.verified &&
        !(isSameDetails && index !== 0 && sameDetailsOptions[index].sameMotherContact && verificationStatus[0].mother_contact.verified)
      ) {
        newErrors[`child_${index}_mother_contact_verification`] = "Mother’s contact number must be verified.";
        hasVerificationErrors = true;
      }
      if (
        mobileVerificationRequired &&
        child.is_single_parent &&
        child.single_parent === "guardian" &&
        !verificationStatus[index].guardian_contact.verified
      ) {
        newErrors[`child_${index}_guardian_contact_verification`] = "Guardian's contact number must be verified.";
        hasVerificationErrors = true;
      }
      if (
        isSameDetails &&
        index !== 0 &&
        !sameDetailsOptions[index].sameFatherContact &&
        child.father_contact_no === childrenData[0].father_contact_no &&
        child.father_contact_no
      ) {
        newErrors[`child_${index}_father_contact_no_same`] = "Father’s contact number matches Child 1’s.";
      }
      if (
        isSameDetails &&
        index !== 0 &&
        !sameDetailsOptions[index].sameMotherContact &&
        child.mother_contact_no === childrenData[0].mother_contact_no &&
        child.mother_contact_no
      ) {
        newErrors[`child_${index}_mother_contact_no_same`] = "Mother’s contact number matches Child 1’s.";
      }
      if (
        isSameDetails &&
        index !== 0 &&
        !sameDetailsOptions[index].sameEmail &&
        child.email === childrenData[0].email &&
        child.email
      ) {
        newErrors[`child_${index}_email_same`] = "Email matches Child 1’s.";
      }
      if (
        !child.is_single_parent &&
        child.father_contact_no &&
        child.mother_contact_no &&
        child.father_contact_no === child.mother_contact_no &&
        !sameContactConfirmed[index] &&
        !newErrors[`child_${index}_father_contact_no`] &&
        !newErrors[`child_${index}_mother_contact_no`]
      ) {
        newErrors[`child_${index}_contact_no_same`] = "Father’s and mother’s contact numbers cannot be the same unless confirmed.";
      }
      if (hasFamilyMembers) {
        for (let memberIndex = 0; memberIndex < familyMembersData.length; memberIndex++) {
          const member = familyMembersData[memberIndex];
          if (!member.ref_role) {
            newErrors[`family_member_${memberIndex}_ref_role`] = "Reference role is required for Alumni/Cousin.";
          }
          if (!member.ref_name) {
            newErrors[`family_member_${memberIndex}_ref_name`] = "Reference name is required for Alumni/Cousin.";
          }
          // if (!member.ref_contact_no || !/^\d{10}$/.test(member.ref_contact_no)) {
          //   newErrors[`family_member_${memberIndex}_ref_contact_no`] = "Valid 10-digit reference contact number is required.";
          // }
          // const skipCurrentStatus = ["ex_student", "ex_staff", "cousin", "other"].includes(member.ref_role);
          // if (!skipCurrentStatus) {
          //   if (member.ref_is_current === undefined || member.ref_is_current === "") {
          //     newErrors[`family_member_${memberIndex}_ref_is_current`] = "Please specify if the family member is currently working.";
          //   }
          // }
          // if (
          //   (member.ref_role === "ex_student" || member.ref_role === "ex_staff" || member.ref_is_current === false) &&
          //   (!member.ref_year_of_leaving || !/^\d{4}$/.test(member.ref_year_of_leaving))
          // ) {
          //   newErrors[`family_member_${memberIndex}_ref_year_of_leaving`] = "Valid 4-digit year of leaving is required.";
          // }
          // if (!member.ref_relation) {
          //   newErrors[`family_member_${memberIndex}_ref_relation`] = "Relationship with family member is required.";
          // }
          // if (member.ref_role === "student" && !member.ref_admission_no) {
          //   newErrors[`family_member_${memberIndex}_ref_admission_no`] = "Reference admission number is required for student role.";
          // }
          // if (member.ref_role === "staff" && !member.ref_employee_code) {
          //   newErrors[`family_member_${memberIndex}_ref_employee_code`] = "Reference employee code is required for staff role.";
          // }
        }
      }
      if (parentType === "existing" && !admissionNumber) {
        newErrors["admission_number"] = "Admission number is required for existing parents.";
      }
    }
    setErrors(newErrors);
    return {
      isValid: Object.keys(newErrors).length === 0,
      hasVerificationErrors,
      errors: newErrors,
    };
  };

  const ensureSameContactConsent = async () => {
    for (let index = 0; index < childrenData.length; index++) {
      const child = childrenData[index];
      const hasSameContacts =
        child.father_contact_no &&
        child.mother_contact_no &&
        child.father_contact_no === child.mother_contact_no;

      if (hasSameContacts && !sameContactConfirmed?.[index]) {
        const result = await Swal.fire({
          icon: 'question',
          title: "Consent Required",
          text: "Father's and Mother's contact numbers are the same. Do you consent to using the same number for both?",
          confirmButtonText: "Yes, I consent",
          cancelButtonText: "Cancel",
          showCancelButton: true,
        });

        if (result.isConfirmed) {
          setSameContactConfirmed((prev) => ({ ...prev, [index]: true }));
        } else {
          return false;
        }
      }
    }

    return true;
  };

  const printEnquiryForm = async () => {
    const consentAccepted = await ensureSameContactConsent();
    if (!consentAccepted) {
      return;
    }

    const { isValid, hasVerificationErrors, errors: validationErrors } = validateForm();
    if (!isValid) {
      let message = "Please fill all required fields correctly";
      if (hasVerificationErrors) {
        message += " and verify the email/contact numbers";
      }
      if (validationErrors.admission_number) {
        message += ", and provide the admission details";
      }
      const firstErrorMessage = Object.values(validationErrors)[0];
      if (firstErrorMessage) {
        message += `. Details: ${firstErrorMessage}`;
      } else {
        message += ".";
      }

      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: message,
      });
      return;
    }

    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    const timestamp = moment().format("YYYY-MM-DD HH:mm:ss");

    // Get child names for the filename
    const childNames = childrenData
      .filter(child => child.full_name)
      .map(child => child.full_name.replace(/\s+/g, '_'))
      .join('_');

    const fileName = `enquiry_${childNames || 'form'}`;

    // Build HTML content for printing
    let printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${fileName}</title>
      <style>
      body { 
        font-family: Arial, sans-serif; 
        margin: 20px; 
        color: #333;
      }
      .header { 
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        border-bottom: 2px solid #0052cc;
        padding-bottom: 20px;
      }
      .school-logo-container {
        flex: 0 0 auto;
      }
      .school-logo {
        max-width: 120px;
        max-height: 120px;
        object-fit: contain;
      }
      .school-info {
        flex: 1;
        text-align: center;
        padding: 0 20px;
      }
      .school-name { 
        font-size: 24px; 
        font-weight: bold; 
        color:rgb(0, 0, 0);
        margin-bottom: 10px;
      }
      .school-details { 
        font-size: 14px; 
        color: #666;
        margin-bottom: 5px;
      }
      .timestamp {
        flex: 0 0 auto;
        text-align: right;
        font-size: 12px;
        color: #888;
      }
      .section { 
        margin: 20px 0; 
      }
      .section-title { 
        background-color: #f8f9fa; 
        padding: 10px; 
        font-weight: bold; 
        border-left: 4px solid #0052cc;
        margin-bottom: 15px;
      }
      .child-section {
        margin: 25px 0;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 8px;
      }
      .row { 
        display: flex; 
        flex-wrap: wrap; 
        margin: 0 -10px;
      }
      .col { 
        flex: 1; 
        min-width: 250px; 
        padding: 0 10px; 
        margin-bottom: 10px;
      }
      .label { 
        font-weight: bold; 
        color: #555;
        margin-bottom: 5px;
      }
      .value { 
        margin-bottom: 12px;
      }
      .transport-fees {
        background-color: #f8f9fa;
        padding: 15px;
        border-radius: 6px;
        margin-top: 10px;
      }
      .footer {
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #ddd;
        font-size: 12px;
        color: #666;
        text-align: center;
      }
      .qr-code-section {
        text-align: center;
        margin: 20px 0;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 8px;
        background: #f8f9fa;
      }
      .qr-code-image {
        width: 150px;
        height: 150px;
        margin: 10px auto;
        display: block;
      }
      @media print {
        body { margin: 0; }
        .no-print { display: none; }
        .header { 
          page-break-after: avoid; 
          break-after: avoid;
        }
        .child-section { 
          page-break-inside: avoid; 
          break-inside: avoid;
        }
      }
    </style>
    </head>
    <body>
  `;

    // Add school header
    if (schoolAutomation) {
      printContent += `
    <div class="header">
      <div class="school-logo-container">
        ${schoolAutomation?.schoolLogo ?
          `<img src="${schoolAutomation?.schoolLogo}" alt="School Logo" class="school-logo" />` :
          '<div style="width: 120px; height: 120px; background: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999;">No Logo</div>'
        }
      </div>
      <div class="school-info">
        <div class="school-name">${schoolAutomation.schoolName || "School Enquiry Form"}</div>
        ${schoolAutomation.schoolAddress ? `<div class="school-details">${schoolAutomation.schoolAddress}</div>` : ''}
        ${schoolAutomation.contact_number ? `<div class="school-details">Contact: ${schoolAutomation.contact_number}</div>` : ''}
        ${schoolAutomation.email ? `<div class="school-details">Email: ${schoolAutomation.email}</div>` : ''}
        <div class="school-details">Session: ${sessions.find(s => s.id === Number(sessionId))?.Name || "N/A"}</div>
      </div>
      <div class="timestamp">
        Generated on:<br/>${timestamp}
      </div>
    </div>
  `;
    } else {
      printContent += `
      <div class="header">
        <div class="school-name">Enquiry Form</div>
        <div class="school-details">Generated on: ${timestamp}</div>
      </div>
    `;
    }

    // Add children data
    childrenData.forEach((child, index) => {
      const className = classes.find(cls => cls.id === Number(child.class))?.Classes || "N/A";
      const streamName = classes
        .find(cls => cls.id === Number(child.class))
        ?.streams.find(s => s.id === Number(child.stream_id))?.name || "N/A";
      const stoppageName = child.transport === "Yes"
        ? stoppages.find(stop => stop.id === Number(child.stoppage_id))?.stop_name || "N/A"
        : "N/A";

      printContent += `
      <div class="child-section">
        <div class="section-title">Child ${index + 1} Details</div>
        
        <div class="section">
          <div class="section-title" style="font-size: 16px;">Student Information</div>
          <div class="row">
            <div class="col">
              <div class="label">Full Name</div>
              <div class="value">${child.full_name || "N/A"}</div>
            </div>
            <div class="col">
              <div class="label">Date of Birth</div>
              <div class="value">${child.dob || "N/A"}</div>
            </div>
            <div class="col">
              <div class="label">Gender</div>
              <div class="value">${child.gender || "N/A"}</div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="label">Class</div>
              <div class="value">${className}</div>
            </div>
            <div class="col">
              <div class="label">Stream</div>
              <div class="value">${streamName}</div>
            </div>
            <div class="col">
              <div class="label">Age Appropriate</div>
              <div class="value">${child.matchesAgeCriteria ? "Yes" : "No"}</div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title" style="font-size: 16px;">Parent Information</div>
          <div class="row">
    `;

      if (child.is_single_parent) {
        if (child.single_parent === "father") {
          printContent += `
          <div class="col">
            <div class="label">Father's Name</div>
            <div class="value">${child.father_name || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Father's Contact</div>
            <div class="value">${child.father_contact_no || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Contact Verified</div>
            <div class="value">${verificationStatus[index].father_contact.verified ? "Yes" : "No"}</div>
          </div>
        `;
        } else if (child.single_parent === "mother") {
          printContent += `
          <div class="col">
            <div class="label">Mother's Name</div>
            <div class="value">${child.mother_name || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Mother's Contact</div>
            <div class="value">${child.mother_contact_no || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Contact Verified</div>
            <div class="value">${verificationStatus[index].mother_contact.verified ? "Yes" : "No"}</div>
          </div>
        `;
        } else {
          printContent += `
          <div class="col">
            <div class="label">Guardian's Name</div>
            <div class="value">${child.guardian_name || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Guardian's Contact</div>
            <div class="value">${child.guardian_contact_no || "N/A"}</div>
          </div>
          <div class="col">
            <div class="label">Relation</div>
            <div class="value">${child.guardian_relation || "N/A"}</div>
          </div>
        `;
        }
      } else {
        printContent += `
        <div class="col">
          <div class="label">Father's Name</div>
          <div class="value">${child.father_name || "N/A"}</div>
        </div>
        <div class="col">
          <div class="label">Father's Contact</div>
          <div class="value">${child.father_contact_no || "N/A"}</div>
        </div>
        <div class="col">
          <div class="label">Father's Contact Verified</div>
          <div class="value">${verificationStatus[index].father_contact.verified ? "Yes" : "No"}</div>
        </div>
        <div class="col">
          <div class="label">Mother's Name</div>
          <div class="value">${child.mother_name || "N/A"}</div>
        </div>
        <div class="col">
          <div class="label">Mother's Contact</div>
          <div class="value">${child.mother_contact_no || "N/A"}</div>
        </div>
        <div class="col">
          <div class="label">Mother's Contact Verified</div>
          <div class="value">${verificationStatus[index].mother_contact.verified ? "Yes" : "No"}</div>
        </div>
      `;
      }

      printContent += `
          </div>
          <div class="row">
            <div class="col">
              <div class="label">Primary Contact</div>
              <div class="value">${child.primary_contact === "father" ? "Father" : child.primary_contact === "mother" ? "Mother" : "Guardian"}</div>
            </div>
            <div class="col">
              <div class="label">Email</div>
              <div class="value">${child.email || "N/A"}</div>
            </div>
            <div class="col">
              <div class="label">Email Verified</div>
              <div class="value">${verificationStatus[index].email.verified ? "Yes" : "No"}</div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title" style="font-size: 16px;">Transport Details</div>
          <div class="row">
            <div class="col">
              <div class="label">Transport Required</div>
              <div class="value">${child.transport || "N/A"}</div>
            </div>
    `;

      if (child.transport === "Yes") {
        printContent += `
            <div class="col">
              <div class="label">Stoppage</div>
              <div class="value">${stoppageName}</div>
            </div>
          </div>
      `;

        if (transportFees[index] && (transportFees[index].one_way_monthly > 0 || transportFees[index].two_way_monthly > 0)) {
          printContent += `
          <div class="transport-fees">
            <div class="label">Transport Fee Details</div>
        `;
         
            printContent += `
            <div class="value">Monthly: ₹${transportFees[index].two_way_monthly}/month</div>
          `;
         

         
            printContent += `
            <div class="value">Annually: (₹${transportFees[index].two_way_annual}/annual)</div>
          `;
         

          printContent += `</div>`;
        }
      } else {
        printContent += `</div>`;
      }
printContent += `
        </div>
      </div>
    `;
    });

    if (hasFamilyMembers) {
      const meaningfulMembers = familyMembersData.filter((member) => {
        if (!member) {
          return false;
        }
        return Boolean(
          member.ref_role ||
          member.ref_name ||
          member.ref_contact_no ||
          member.ref_admission_no ||
          member.ref_employee_code ||
          member.ref_note ||
          member.ref_relation
        );
      });

      if (meaningfulMembers.length > 0) {
        printContent += `
      <div class="section">
        <div class="section-title" style="font-size: 16px;">Associated Member Details</div>
    `;

        meaningfulMembers.forEach((member, memberIndex) => {
          const getRoleLabel = (roleValue) => {
  const roleOption = referenceRoleOptions.find(opt => opt.value === roleValue);
  return roleOption ? roleOption.label : roleValue || "N/A";
};

const roleLabel = getRoleLabel(member.ref_role);
          printContent += `
        <div style="border: 1px solid #ddd; border-radius: 8px; padding: 12px; margin-bottom: 12px;">
          <div class="label" style="font-weight: 600;">Associated Member ${memberIndex + 1}</div>
          <div class="value" style="margin-top: 8px;">
            <strong>Role / Association with School *</strong>: ${roleLabel}
          </div>
          <div class="value">
            <strong>Associated Member Name *</strong>: ${member.ref_name || "N/A"}
          </div>
          <div class="value">
            <strong>Member's Relation with the Child (Seeking Admission)</strong>: ${member.ref_relation || "N/A"}
          </div>
          <div class="value">
            <strong>Associated Contact No.</strong>: ${member.ref_contact_no || "N/A"}
          </div>
          <div class="value">
            <strong>Note - Any other Information</strong>: ${member.ref_note || "N/A"}
          </div>
        </div>
      `;
        });

        printContent += `
      </div>
    `;
      }

      // Add class-wise enquiry text and notes to print content
      printContent += `
    <div class="section">
      <div class="section-title" style="font-size: 16px;">Admission Process</div>
      <div style="padding: 15px; background: #f8f9fa; border-radius: 6px;">
  `;

      getChildEnquiryTexts().forEach((item) => {
        const heading =
          childrenData.length > 1
            ? `Child ${item.index + 1}${item.childName ? ` (${item.childName})` : ""} - ${item.className}`
            : item.className;
        printContent += `
      <div style="margin-bottom: 20px;">
        <h4 style="color: #0052cc; margin-bottom: 10px;">${heading}</h4>
        <div style="font-size: 14px; line-height: 1.5;">
          ${item.text.replace(/\n/g, '<br/>')}
        </div>
      </div>
    `;
      });

      printContent += `
        <div style="margin-bottom: 20px; background: #fff8e1; border: 1px solid #ffc107; border-left: 5px solid #ffc107; border-radius: 6px; padding: 12px 16px;">
          <h4 style="color: #b45309; margin-bottom: 10px;">Note</h4>
          ${ENQUIRY_NOTES.map(
            (lines) => `<ul style="font-size: 14px; line-height: 1.5;">${lines.map((line) => `<li>${line}</li>`).join("")}</ul>`
          ).join("")}
        </div>
      </div>
    </div>
  `;
      printContent += `
        </div>
      </div>
    `;
    };

    // Add footer
    printContent += `
      <div class="footer">
        <div>Generated on: ${timestamp}</div>
        <div>This is a computer-generated enquiry form.</div>
      </div>
      
      <div class="no-print" style="text-align: center; margin-top: 20px;">
        <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">Print Form</button>
        <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 5px; cursor: pointer; margin-left: 10px;">Close</button>
      </div>
    </body>
    </html>
  `;

    // Write content to print window
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Focus on the print window
    printWindow.focus();

    Swal.fire({
      icon: "success",
      title: "Print Ready",
      text: "The enquiry form is ready for printing. Use the print button in the new window.",
    });
  };

  const handleParentTypeChange = (selectedOption) => {
    setParentType(selectedOption.value);

    if (selectedOption.value === "new") {
      setChildrenData([
        {
          full_name: "",
          dob: "",
          gender: "",
          class: "",
          showAllClasses: false,
          recommendedClass: "",
          recommendedClassIds: [],
          classMessage: "",
          matchesAgeCriteria: true,
          stream_id: "",
          father_name: "",
          mother_name: "",
          father_contact_no: "",
          mother_contact_no: "",
          primary_contact: "father",
          email: "",
          transport: "No",
          stoppage_id: "",
          contactReason: "",
          is_ref: false,
          ref_role: "",
          ref_admission_no: "",
          ref_year_of_leaving: "",
          ref_contact_no: "",
          ref_note: "",
          ref_name: "",
          ref_employee_code: "",
          is_single_parent: false,
          single_parent: "",
          guardian_name: "",
          guardian_contact_no: "",
          guardian_relation: "",
          admission_num: "",
          has_sibling: false,
          created_by_student: true,
        },
      ]);
      setContactEditMode([
        { father: false, mother: false, guardian: false }
      ]);

      setVerificationStatus([
        {
          email: { verified: false, otp: "", sent: false },
          father_contact: { verified: false },
          mother_contact: { verified: false },
          guardian_contact: { verified: false },
        },
      ]);

      setAdmissionNumber("");
      setStudentDetails(null);
      setIsSameDetails(false);
    }
  };


  
  const handleSubmit = async (e) => {
  e.preventDefault();

  const consentAccepted = await ensureSameContactConsent();
  if (!consentAccepted) return;

  // Validate form
  const { isValid, hasVerificationErrors, errors: validationErrors } = validateForm();
  if (!isValid) {
    let message = "Please fill all required fields correctly";
    if (hasVerificationErrors) message += " and verify the email/contact numbers";
    if (validationErrors.admission_number) message += ", and provide the admission details";
    const firstErrorMessage = Object.values(validationErrors)[0];
    if (firstErrorMessage) message += `. Details: ${firstErrorMessage}`;
    else message += ".";

    Swal.fire({
      icon: "error",
      title: "Validation Error",
      text: message,
    });
    return;
  }

  if (!sessionId) {
    Swal.fire({
      icon: "error",
      title: "Session Error",
      text: "No current session found. Please contact support at support@mirai.healthcare.",
    });
    return;
  }

  setLoading(true);

  try {
    const createPayloads = [];

    childrenData.forEach((child, index) => {
      const enquiryData = {
        student_full_name: child.full_name,
        gender: child.gender,
        dob: child.dob,
        class: parseInt(child.class, 10),
        stream_id: parseInt(child.stream_id, 10),
        session: parseInt(sessionId, 10),
        is_transport: child.transport === "Yes",
        created_by_student: true,
        stoppage_id: child.transport === "Yes" ? parseInt(child.stoppage_id, 10) : null,
        fathername: child.is_single_parent && child.single_parent !== "father" ? null : child.father_name,
        mothername: child.is_single_parent && child.single_parent !== "mother" ? null : child.mother_name,
        contactno: child.is_single_parent
          ? (child.single_parent === "father"
              ? child.father_contact_no
              : child.single_parent === "mother"
              ? child.mother_contact_no
              : child.guardian_contact_no)
          : child.primary_contact === "father"
          ? child.father_contact_no
          : child.mother_contact_no,
        primary_contact_no: child.is_single_parent
          ? child.single_parent === "father"
            ? child.father_contact_no
            : child.single_parent === "mother"
            ? child.mother_contact_no
            : child.guardian_contact_no
          : child.primary_contact === "father"
          ? child.father_contact_no
          : child.mother_contact_no,
        emailid: child.email,
        enquirysources: "Online",
        enquirydatetime: moment().toISOString(),
        is_email_verified: verificationStatus[index].email.verified,
        is_primary_contact_verified: child.is_single_parent
          ? child.single_parent === "father"
            ? verificationStatus[index].father_contact.verified
            : child.single_parent === "mother"
            ? verificationStatus[index].mother_contact.verified
            : verificationStatus[index].guardian_contact.verified
          : child.primary_contact === "father"
          ? verificationStatus[index].father_contact.verified
          : verificationStatus[index].mother_contact.verified,
        is_father_contact_verified: Boolean(verificationStatus[index].father_contact?.verified),
        is_mother_contact_verified: Boolean(verificationStatus[index].mother_contact?.verified),
        is_gaurdian_contact_verified: Boolean(verificationStatus[index].guardian_contact?.verified),
        is_single_parent: child.is_single_parent,
        single_parent: child.is_single_parent ? child.single_parent : null,
        is_bonafied_require: child.is_bonafide_required,
        ...(child.single_parent === "guardian" && {
          guardian_name: child.guardian_name,
          guardian_relation: child.guardian_relation,
          guardian_mobile_no: child.guardian_contact_no,
        }),
        ...(child.father_contact_no &&
          child.mother_contact_no &&
          child.father_contact_no === child.mother_contact_no && {
            consent: [`I give consent for saving same phone numbers`],
          }),
        ...(child.admission_num && child.has_sibling && {
          admission_num: child.admission_num,
          has_sibling: true,
        }),
      };

      // Clean null/empty values
      Object.keys(enquiryData).forEach((key) => {
        const value = enquiryData[key];
        if (value === null || value === "" || (typeof value === "number" && Number.isNaN(value))) {
          delete enquiryData[key];
        }
      });

      // Add referral info
      if (hasFamilyMembers) {
        enquiryData.is_ref = true;
        enquiryData.referrals = familyMembersData.map((member) => ({
          ref_name: member.ref_name,
          ref_role: member.ref_role,
          ...(member.ref_role &&
            ["student", "ex_student"].includes(member.ref_role) &&
            member.ref_admission_no && { ref_admission_no: member.ref_admission_no }),
          ...(member.ref_role &&
            ["staff", "ex_staff"].includes(member.ref_role) &&
            member.ref_employee_code && { ref_employee_code: member.ref_employee_code }),
          ...(member.ref_role &&
            ["ex_student", "ex_staff"].includes(member.ref_role) &&
            member.ref_year_of_leaving && {
              ref_year_of_leaving: parseInt(member.ref_year_of_leaving, 10),
            }),
          ...(member.ref_contact_no && { ref_contact_no: member.ref_contact_no }),
          ...(member.ref_note && { ref_note: member.ref_note }),
          ...(typeof member.ref_is_current === "boolean" && { ref_is_current: member.ref_is_current }),
          ...(member.ref_relation && { ref_relation: member.ref_relation }),
        }));
      }

      createPayloads.push(enquiryData);
    });

    const currentSchoolId = selectedSchool?.value || localStorage.getItem("schoolId");

    // Only POST API call
    const response = await fetch("https://api.mirai.healthcare/api/enquiry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        "x-auth": authtoken,
      },
      body: JSON.stringify(createPayloads),
    });

    const createResponse = await response.json().catch(() => ({ success: response.ok }));

    // if (!response.ok || createResponse?.success === false) {
    //   throw new Error(createResponse?.message || "Failed to create enquiry.");
    // }

    if (!response.ok || createResponse?.success === false) {
          // Check for duplicate record error specifically
          if (createResponse?.error?.includes("Duplicate record") ||
            createResponse?.message?.includes("Duplicate record") ||
            createResponse?.error?.includes("already exist") ||
            createResponse?.message?.includes("already exist")) {

            // Swal.fire({
            //   icon: "error",
            //   title: "Duplicate Record Found",
            //   text: "The enquiry details already exist. Please check the information and contact to administration.",
            //   confirmButtonText: "OK"
            // });
            Swal.fire({
              icon: 'error',
              title: 'Duplicate Record Found',
              text: `The enquiry details already exist. Please check the information and contact to administration.`,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true,
              background: '#fff3cd',
              iconColor: '#856404',
              customClass: {
                title: 'text-warning',
                popup: 'swal2-toast'
              }
            });
            return;
          }

          throw new Error(createResponse?.message || createResponse?.error || "Failed to create enquiry.");
        }

    Swal.fire({
      icon: "success",
      title: "Enquiry Created",
      text: "All enquiries have been successfully created.",
    });

    await printEnquiryForm();
    navigate("/");

    // Reset form state
    resetFormState();

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
  } finally {
    setLoading(false);
  }
};

// Helper function to reset form state
const resetFormState = () => {
  setChildrenData([
    {
      full_name: "",
      dob: "",
      class: "",
      gender: "",
      showAllClasses: false,
      recommendedClass: "",
      recommendedClassIds: [],
      classMessage: "",
      matchesAgeCriteria: true,
      stream_id: "",
      father_name: "",
      mother_name: "",
      father_contact_no: "",
      mother_contact_no: "",
      primary_contact: "father",
      email: "",
      transport: "No",
      stoppage_id: "",
      contactReason: "",
      is_ref: false,
      ref_role: "",
      ref_admission_no: "",
      ref_year_of_leaving: "",
      ref_contact_no: "",
      ref_note: "",
      ref_name: "",
      ref_employee_code: "",
      is_single_parent: false,
      single_parent: "",
      guardian_name: "",
      guardian_contact_no: "",
      guardian_relation: "",
      admission_num: "",
      has_sibling: false,
      created_by_student: true,
    },
  ]);
  setVerificationStatus([
    {
      email: { verified: false, otp: "", sent: false },
      father_contact: { verified: false },
      mother_contact: { verified: false },
      guardian_contact: { verified: false },
    },
  ]);
  setSameDetailsOptions([
    {
      sameFatherContact: true,
      sameMotherContact: true,
      sameEmail: true,
    },
  ]);
  setSameContactConfirmed({});
  setIsSameDetails(false);
  setParentType("new");
  setAdmissionNumber("");
  setStudentDetails(null);
  setShowStudentModal(false);
  setMobileVerificationData([
    {
      father_contact: { uuid: "", otpSent: false },
      mother_contact: { uuid: "", otpSent: false },
      guardian_contact: { uuid: "", otpSent: false },
    },
  ]);
  setMobileOTP([
    {
      father_contact: "",
      mother_contact: "",
      guardian_contact: "",
    },
  ]);
  setExistingEnquiryRecords([null]);
};

  const handleShowAllClasses = (index, checked) => {
    const newChildrenData = [...childrenData];
    newChildrenData[index].showAllClasses = checked;

    if (!checked) {
      if (!newChildrenData[index].recommendedClassIds || newChildrenData[index].recommendedClassIds.length === 0) {
        const { id, ids, matchesAge } = calculateRecommendedClass(newChildrenData[index].dob);
        newChildrenData[index].recommendedClass = id;
        newChildrenData[index].recommendedClassIds = ids;
        newChildrenData[index].matchesAgeCriteria = matchesAge;
      }

      const recommendedIds = newChildrenData[index].recommendedClassIds || [];
      if (recommendedIds.length > 0) {
        newChildrenData[index].class = recommendedIds[0];
        newChildrenData[index].recommendedClass = recommendedIds[0];
      }

      const isAgeAppropriate = recommendedIds.includes(Number(newChildrenData[index].class));
      newChildrenData[index].matchesAgeCriteria = isAgeAppropriate;
    newChildrenData[index].classMessage = isAgeAppropriate
      ? ""
      : "Selected class doesn't match age criteria.";
    }

    setChildrenData(newChildrenData);
  };


  // Add this useEffect to fetch schools
useEffect(() => {
  if (existingEnquiryModal?.enquiry) {
    const enquiry = existingEnquiryModal.enquiry;

    const updatedStatus = [...verificationStatus];
    updatedStatus[0].email.verified = enquiry.is_email_verified ? true : false;
    updatedStatus[0].email.sent = false;

    setVerificationStatus(updatedStatus);
  }
}, [existingEnquiryModal]);


// useEffect(() => {
//   if (existingEnquiryModal?.enquiry) {
//     const enquiry = existingEnquiryModal.enquiry;

//     const updatedStatus = [...verificationStatus];

//     // assuming index = 0 for enquiry modal data
//     const idx = 0;

//     // Email verification
//     updatedStatus[idx].email.verified = enquiry.is_email_verified ? true : false;
//     updatedStatus[idx].email.sent = false;

//     // Father contact verification
//     updatedStatus[idx].father_contact.verified = enquiry.is_father_contact_verified ? true : false;
//     updatedStatus[idx].father_contact.sent = false;

//     // Mother contact verification
//     updatedStatus[idx].mother_contact.verified = enquiry.is_mother_contact_verified ? true : false;
//     updatedStatus[idx].mother_contact.sent = false;

//     // Guardian contact verification
//     updatedStatus[idx].guardian_contact.verified = enquiry.is_gaurdian_contact_verified ? true : false;
//     updatedStatus[idx].guardian_contact.sent = false;

//     setVerificationStatus(updatedStatus);
//   }
// }, [existingEnquiryModal]);



  return (
    <div className="page-wrapper">
      <div className="content">
        

        {/* <div className="header">
      <div className="header-left active">
        <span className="logo logo-normal">
        <img src={schoolAutomation?.schoolLogo} style={{width:"55%", textAlign:"left", float:"left"}} />
        </span>
      </div>

              <Button variant="primary">Login</Button>

      

    </div> */}

    <div className="header d-flex justify-content-between align-items-center">
  
  <div className="header-left active">
    <span className="logo logo-normal">
      <img
        src={schoolAutomation?.schoolLogo}
        style={{ width: "55%" }}
        alt="logo"
      />
    </span>
  </div>
<Link to={routes.login}>
  <button className="btn btn-primary" variant="primary">Login</button>
  </Link>

</div>

        <>
        <style>{`
            .container { max-width: 1200px; margin: 0 auto; padding: 20px; }
            .card { border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); }
            .card-header { background: linear-gradient(45deg, #0052cc, #0066ff); color: white; padding: 15px 20px; border-radius: 8px 8px 0 0; }
            .form-control, .ant-select { border-radius: 8px; padding: 8px; }
            .form-control:focus, .ant-select-focused { border-color: #007bff; box-shadow: 0 0 5px rgba(0,123,255,0.3); }
            .error-text { color: #dc3545; font-size: 0.85rem; }
            .accordion-button { font-weight: 600; background-color: #f8f9fa; }
            .accordion-item { border-radius: 8px; margin-bottom: 10px; border: 1px solid #dee2e6; }
            .btn-primary { border-radius: 6px; padding: 8px 20px; background-color: #007bff; border-color: #007bff; }
            .btn-outline-primary { border-radius: 6px; padding: 8px 20px; }
            .react-select__control { border-radius: 8px; min-height: 40px; }
            .otp-input { width: 120px; }
            .verified-text { color: #28a745; font-size: 0.9rem; }
            .rule-box { border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; margin-top: 10px; background: #f9f9f9; }
            .rule-title { font-weight: bold; font-size: 15px; }
            .rule-desc { font-size: 14px; color: #555; }
            .rule-link { font-size: 14px; color: #007bff; text-decoration: none; }
            .rule-link:hover { text-decoration: underline; }
            .bonafide-info { font-size: 0.9rem; color: #17a2b8; }
            .admission-input { max-width: 200px; }
            .student-modal-img { max-width: 150px; height: auto; border-radius: 8px; margin-bottom: 15px; }
            .modal-content { border-radius: 12px; }
            .modal-header { background: linear-gradient(45deg, #0052cc, #0066ff); color: white; border-radius: 8px 8px 0 0; }
            .modal-body { padding: 20px; }
            .modal-body p { margin-bottom: 10px; font-size: 15px; }
            .modal-body strong { font-weight: 600; }
            .enquiry_data_div_1 { margin-top: 20px; }
            .enquiry_data_div_2 { margin-left: 20px; }
            .enquiry_data_div_2 ul { list-style-type: disc; padding-left: 20px; }
            .enquiry_data_div_2 li { margin-bottom: 10px; font-size: 14px; }
        `}</style>




          <div className="">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">Enquiry Form</h5>
                  </div>
                  <div className="card-body">
                    <form className="needs-validation" noValidate onSubmit={handleSubmit}>
                      <div className="row g-3">

                        <div className="col-md-3">
                          <label className="form-label">
                            Parent Type <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={parentTypeOptions}
                            value={parentTypeOptions.find((pt) => pt.value === parentType)}
                            onChange={handleParentTypeChange}
                          />
                        </div>
                        {/* {parentType === "existing" && (
                          <div className="col-md-3">
                            <label className="form-label">
                              Sibling’s Adm. No. (Studying with us) <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control admission-input"
                                value={admissionNumber}
                                onChange={(e) => setAdmissionNumber(e.target.value)}
                                placeholder="Enter Sibling’s Adm. No. (Studying with us)"
                              />
                              <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={fetchStudentDetails}
                                disabled={loading || !admissionNumber}
                              >
                                Search
                              </button>
                            </div>
                            {errors["admission_number"] && (
                              <div className="error-text">{errors["admission_number"]}</div>
                            )}
                          </div>
                        )} */}
                        {parentType === "existing" && (
                          <>
                            <div className="col-md-3">
                              <label className="form-label">
                                Sibling’s Adm. No. (Studying with us){" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control admission-input"
                                  value={admissionNumber}
                                  onChange={(e) =>
                                    setAdmissionNumber(e.target.value)
                                  }
                                  placeholder="Enter Admission Number"
                                />
                                <button
                                  className="btn btn-outline-primary"
                                  onClick={handleSendOtp}
                                  disabled={loading || !admissionNumber || getOtpCooldown("sibling") > 0}
                                >
                                  {loading ? "Sending OTP..." : getOtpButtonLabel("sibling", otpSiblingSent)}
                                </button>
                              </div>
                              {!otpVerified && (
                                <small className="text-muted d-block mt-1">
                                  {otpSiblingSent && siblingOtpMobile
                                    ? `OTP sent to the registered mobile number ending with ${siblingOtpMobile}.`
                                    : "OTP will be sent to the mobile number registered with the sibling's admission."}
                                </small>
                              )}
                              {otpVerified && (
                                <p className="text-success mt-3 fw-bold">
                                  ✅ OTP Verified Successfully
                                </p>
                              )}
                            </div>

                            {otpSiblingSent && !otpVerified && (
                              <div className="col-md-3">
                                <label className="form-label">Verify OTP</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control admission-input"
                                    value={otpSiblingVerify}
                                    onChange={(e) =>
                                      setotpSiblingVerify(e.target.value)
                                    }
                                    placeholder="Enter OTP"
                                  />
                                  <button
                                    className="btn btn-outline-primary"
                                    onClick={handleVerifyOtp}
                                    disabled={loading || !otpSiblingVerify}
                                  >
                                    {loading ? "Verifying..." : "Verify OTP"}
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        <div className="col-md-3">
                          <label className="form-label">
                            No. of Children seeking Admission <span className="text-danger">*</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            options={childCountOptions}
                            value={childCountOptions.find((opt) => opt.value === childCount)}
                            onChange={handleChildCountChange}
                            placeholder="Select Number"
                          />
                        </div>
                        {childCount > 1 && (
                          <div className="col-md-3">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isSameDetails}
                                onChange={(e) => handleSameDetailsChange(e.target.checked)}
                                id="sameDetails"
                              />
                              <label className="form-check-label" htmlFor="sameDetails">
                                Same parent, transport, and associated details for all children
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="accordion mt-4" id="childrenAccordion">
                        {childrenData.map((child, index) => {
                          const selectedClassOption = formattedClasses.find(
                            (cls) => cls.value === Number(child.class)
                          );
                          const selectedClassLabel = selectedClassOption?.label || "";

                          return (
                            <div className="accordion-item" key={index}>
                            <h2 className="accordion-header" id={`heading${index}`}>
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${index}`}
                                aria-expanded={index === 0}
                                aria-controls={`collapse${index}`}
                              >
                                Child {index + 1}
                              </button>
                            </h2>
                            <div
                              id={`collapse${index}`}
                              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                              aria-labelledby={`heading${index}`}
                              data-bs-parent="#childrenAccordion"
                            >

                              <div className="accordion-body">
                                <h5 className="mt-4">Parent Details</h5>
                                <div className="row g-3">
                                  {isSameDetails && index !== 0 ? (
                                    <div className="col-12">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={sameDetailsOptions[index].sameFatherContact}
                                          onChange={(e) =>
                                            handleSameDetailsOptionChange(index, "sameFatherContact", e.target.checked)
                                          }
                                          id={`sameFatherContact${index}`}
                                        />
                                        <label className="form-check-label" htmlFor={`sameFatherContact${index}`}>
                                          Use same father’s contact details as Child 1
                                        </label>
                                      </div>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={sameDetailsOptions[index].sameMotherContact}
                                          onChange={(e) =>
                                            handleSameDetailsOptionChange(index, "sameMotherContact", e.target.checked)
                                          }
                                          id={`sameMotherContact${index}`}
                                        />
                                        <label className="form-check-label" htmlFor={`sameMotherContact${index}`}>
                                          Use same mother’s contact details as Child 1
                                        </label>
                                      </div>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={sameDetailsOptions[index].sameEmail}
                                          onChange={(e) =>
                                            handleSameDetailsOptionChange(index, "sameEmail", e.target.checked)
                                          }
                                          id={`sameEmail${index}`}
                                        />
                                        <label className="form-check-label" htmlFor={`sameEmail${index}`}>
                                          Use same email as Child 1
                                        </label>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="col-12">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={child.is_single_parent}
                                        onChange={(e) => handleChildChange(index, "is_single_parent", e.target.checked)}
                                        id={`isSingleParent${index}`}
                                      />
                                      <label className="form-check-label" htmlFor={`isSingleParent${index}`}>
                                        Single Parent
                                      </label>
                                    </div>
                                  </div>

                                  {child.is_single_parent ? (
                                    <>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Parent Type <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={singleParentOptions}
                                          value={singleParentOptions.find((opt) => opt.value === child.single_parent)}
                                          onChange={(selectedOption) =>
                                            handleChildChange(index, "single_parent", selectedOption ? selectedOption.value : "")
                                          }
                                          placeholder="Select Parent Type"
                                        />
                                        {errors[`child_${index}_single_parent`] && (
                                          <div className="error-text">{errors[`child_${index}_single_parent`]}</div>
                                        )}
                                      </div>

                                      {child.single_parent === "father" && (
                                        <>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Father's Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.father_name}
                                              onChange={(e) => handleChildChange(index, "father_name", e.target.value)}
                                              placeholder="Father's Name"
                                              disabled={isSameDetails && index !== 0}
                                            />
                                            {errors[`child_${index}_father_name`] && (
                                              <div className="error-text">{errors[`child_${index}_father_name`]}</div>
                                            )}
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Father's Contact Number <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={child.father_contact_no}
                                                onChange={(e) => handleChildChange(index, "father_contact_no", e.target.value)}
                                                placeholder="10-digit number"
                                                maxLength="10"
                                                disabled={
                                                  (verificationStatus[index].father_contact.verified && !contactEditMode[index]?.father) ||
                                                  (isSameDetails && index !== 0 && sameDetailsOptions[index].sameFatherContact) ||
                                                  (isSameDetails && index !== 0)
                                                }
                                              />
                                              {mobileVerificationRequired && !verificationStatus[index].father_contact.verified && (
                                                <button
                                                  className="btn btn-outline-primary"
                                                  type="button"
                                                  onClick={() => sendMobileOTP(index, "father_contact")}
                                                  disabled={
                                                    !child.father_contact_no ||
                                                    !/^\d{10}$/.test(child.father_contact_no) ||
                                                    loading ||
                                                    getOtpCooldown(`father_contact_${index}`) > 0
                                                  }
                                                >
                                                  {getOtpButtonLabel(`father_contact_${index}`, mobileVerificationData[index]?.father_contact?.otpSent)}
                                                </button>
                                              )}
                                            </div>
                                            {mobileVerificationData[index]?.father_contact?.otpSent && !verificationStatus[index].father_contact.verified && (
                                              <div className="mt-2">
                                                <div className="input-group">
                                                <input
                                                  type="text"
                                                  className="form-control otp-input new_OTP"
                                                  placeholder="Enter OTP"
                                                  value={mobileOTP[index]?.father_contact || ""}
                                                  onChange={(e) => {
                                                    const newMobileOTP = [...mobileOTP];
                                                    newMobileOTP[index] = {
                                                      ...newMobileOTP[index],
                                                      father_contact: e.target.value
                                                    };
                                                    setMobileOTP(newMobileOTP);
                                                  }}
                                                  maxLength="6"
                                                />
                                                <button
                                                  className="btn btn-outline-primary new_OTP_button"
                                                  type="button"
                                                  onClick={() => verifyMobileOTP(index, "father_contact")}
                                                  disabled={!mobileOTP[index]?.father_contact || !/^\d{4,6}$/.test(mobileOTP[index]?.father_contact)}
                                                >
                                                  Verify OTP
                                                </button>
                                                </div>
                                              </div>
                                            )}
                                            {errors[`child_${index}_father_contact_no`] && (
                                              <div className="error-text">{errors[`child_${index}_father_contact_no`]}</div>
                                            )}
                                            {errors[`child_${index}_father_contact_verification`] && (
                                              <div className="error-text">{errors[`child_${index}_father_contact_verification`]}</div>
                                            )}
                                            {verificationStatus[index].father_contact.verified && (
                                              <div className="verified-text d-flex align-items-center gap-2 mt-2">
                                                <span>Contact number verified</span>
                                                {!contactEditMode[index]?.father && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={() => handleContactEdit(index, "father_contact")}
                                                  >
                                                    Edit
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                            {contactEditMode[index]?.father && !verificationStatus[index].father_contact.verified && (
                                              <div className="text-muted small mt-1">
                                                Update the number and resend OTP for verification.
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      )}

                                      {child.single_parent === "mother" && (
                                        <>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Mother's Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.mother_name}
                                              onChange={(e) => handleChildChange(index, "mother_name", e.target.value)}
                                              placeholder="Mother's Name"
                                              disabled={isSameDetails && index !== 0}
                                            />
                                            {errors[`child_${index}_mother_name`] && (
                                              <div className="error-text">{errors[`child_${index}_mother_name`]}</div>
                                            )}
                                          </div>
                                          {child.is_single_parent && child.single_parent === "mother" && (
                                            <>
                                              {/* Mother's Contact Number Section */}
                                              <div className="col-md-4">
                                                <label className="form-label">
                                                  Mother's Contact Number <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={child.mother_contact_no}
                                                    onChange={(e) => handleChildChange(index, "mother_contact_no", e.target.value)}
                                                    placeholder="10-digit number"
                                                    maxLength="10"
                                                    disabled={
                                                      (verificationStatus[index].mother_contact.verified && !contactEditMode[index]?.mother) ||
                                                      (isSameDetails && index !== 0 && sameDetailsOptions[index].sameMotherContact) ||
                                                      (isSameDetails && index !== 0)
                                                    }
                                                  />
                                                  {mobileVerificationRequired && !verificationStatus[index].mother_contact.verified && (
                                                    <button
                                                      className="btn btn-outline-primary"
                                                      type="button"
                                                      onClick={() => sendMobileOTP(index, "mother_contact")}
                                                      disabled={
                                                        !child.mother_contact_no ||
                                                        !/^\d{10}$/.test(child.mother_contact_no) ||
                                                        loading ||
                                                        getOtpCooldown(`mother_contact_${index}`) > 0
                                                      }
                                                    >
                                                      {getOtpButtonLabel(`mother_contact_${index}`, mobileVerificationData[index]?.mother_contact?.otpSent)}
                                                    </button>
                                                  )}
                                                </div>

                                                {/* OTP Input Section - YEH ADD KARNA HAI */}
                                                {mobileVerificationData[index]?.mother_contact?.otpSent && !verificationStatus[index].mother_contact.verified && (
                                                  <div className="mt-2">
                                                    <div className="input-group">
                                                    <input
                                                      type="text"
                                                      className="form-control otp-input new_OTP"
                                                      placeholder="Enter OTP"
                                                      value={mobileOTP[index]?.mother_contact || ""}
                                                      onChange={(e) => {
                                                        const newMobileOTP = [...mobileOTP];
                                                        newMobileOTP[index] = {
                                                          ...newMobileOTP[index],
                                                          mother_contact: e.target.value
                                                        };
                                                        setMobileOTP(newMobileOTP);
                                                      }}
                                                      maxLength="6"
                                                    />
                                                    <button
                                                      className="btn btn-outline-primary new_OTP_button"
                                                      type="button"
                                                      onClick={() => verifyMobileOTP(index, "mother_contact")}
                                                      disabled={!mobileOTP[index]?.mother_contact || !/^\d{4,6}$/.test(mobileOTP[index]?.mother_contact)}
                                                    >
                                                      Verify OTP
                                                    </button>
                                                  </div>
                                                  </div>
                                                )}

                                                {errors[`child_${index}_mother_contact_no`] && (
                                                  <div className="error-text">{errors[`child_${index}_mother_contact_no`]}</div>
                                                )}
                                                {errors[`child_${index}_mother_contact_verification`] && (
                                                  <div className="error-text">{errors[`child_${index}_mother_contact_verification`]}</div>
                                                )}
                                                {verificationStatus[index].mother_contact.verified && (
                                                  <div className="verified-text d-flex align-items-center gap-2 mt-2">
                                                    <span>Contact number verified</span>
                                                    {!contactEditMode[index]?.mother && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-sm btn-link p-0"
                                                        onClick={() => handleContactEdit(index, "mother_contact")}
                                                      >
                                                        Edit
                                                      </button>
                                                    )}
                                                  </div>
                                                )}
                                                {contactEditMode[index]?.mother && !verificationStatus[index].mother_contact.verified && (
                                                  <div className="text-muted small mt-1">
                                                    Update the number and resend OTP for verification.
                                                  </div>
                                                )}
                                              </div>
                                            </>
                                          )}
                                        </>
                                      )}

                                      {(child.single_parent === "guardian") && (
                                        <>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Guardian's Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.guardian_name}
                                              onChange={(e) => handleChildChange(index, "guardian_name", e.target.value)}
                                              placeholder="Guardian's Name"
                                              disabled={isSameDetails && index !== 0}
                                            />
                                            {errors[`child_${index}_guardian_name`] && (
                                              <div className="error-text">{errors[`child_${index}_guardian_name`]}</div>
                                            )}
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Guardian's Relation <span className="text-danger">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.guardian_relation}
                                              onChange={(e) => handleChildChange(index, "guardian_relation", e.target.value)}
                                              placeholder="e.g., Uncle, Aunt, Grandparent"
                                              disabled={isSameDetails && index !== 0}
                                            />
                                            {errors[`child_${index}_guardian_relation`] && (
                                              <div className="error-text">{errors[`child_${index}_guardian_relation`]}</div>
                                            )}
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Guardian's Contact Number <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={child.guardian_contact_no}
                                                onChange={(e) => handleChildChange(index, "guardian_contact_no", e.target.value)}
                                                placeholder="10-digit number"
                                                maxLength="10"
                                                disabled={
                                                  (verificationStatus[index].guardian_contact.verified && !contactEditMode[index]?.guardian) ||
                                                  (isSameDetails && index !== 0)
                                                }
                                              />
                                              {mobileVerificationRequired && !verificationStatus[index].guardian_contact.verified && (
                                                <button
                                                  className="btn btn-outline-primary"
                                                  type="button"
                                                  onClick={() => sendMobileOTP(index, "guardian_contact")}
                                                  disabled={
                                                    !child.guardian_contact_no ||
                                                    !/^\d{10}$/.test(child.guardian_contact_no) ||
                                                    loading ||
                                                    getOtpCooldown(`guardian_contact_${index}`) > 0
                                                  }
                                                >
                                                  {getOtpButtonLabel(`guardian_contact_${index}`, mobileVerificationData[index]?.guardian_contact?.otpSent)}
                                                </button>
                                              )}
                                            </div>
                                            {mobileVerificationData[index]?.guardian_contact?.otpSent && !verificationStatus[index].guardian_contact.verified && (
                                              <div className="mt-2">
                                                <div className="input-group">
                                                <input
                                                  type="text"
                                                  className="form-control otp-input new_OTP"
                                                  placeholder="Enter OTP"
                                                  value={mobileOTP[index]?.guardian_contact || ""}
                                                  onChange={(e) => {
                                                    const newMobileOTP = [...mobileOTP];
                                                    newMobileOTP[index] = {
                                                      ...newMobileOTP[index],
                                                      guardian_contact: e.target.value
                                                    };
                                                    setMobileOTP(newMobileOTP);
                                                  }}
                                                  maxLength="6"
                                                />
                                                <button
                                                  className="btn btn-outline-primary new_OTP_button"
                                                  type="button"
                                                  onClick={() => verifyMobileOTP(index, "guardian_contact")}
                                                  disabled={!mobileOTP[index]?.guardian_contact || !/^\d{4,6}$/.test(mobileOTP[index]?.guardian_contact)}
                                                >
                                                  Verify OTP
                                                </button>
                                                </div>
                                              </div>
                                            )}
                                            {errors[`child_${index}_guardian_contact_no`] && (
                                              <div className="error-text">{errors[`child_${index}_guardian_contact_no`]}</div>
                                            )}
                                            {errors[`child_${index}_guardian_contact_verification`] && (
                                              <div className="error-text">{errors[`child_${index}_guardian_contact_verification`]}</div>
                                            )}
                                            {verificationStatus[index].guardian_contact.verified && (
                                              <div className="verified-text d-flex align-items-center gap-2 mt-2">
                                                <span>Contact number verified</span>
                                                {!contactEditMode[index]?.guardian && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={() => handleContactEdit(index, "guardian_contact")}
                                                  >
                                                    Edit
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                            {contactEditMode[index]?.guardian && !verificationStatus[index].guardian_contact.verified && (
                                              <div className="text-muted small mt-1">
                                                Update the number and resend OTP for verification.
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Father’s Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={child.father_name}
                                          onChange={(e) => handleChildChange(index, "father_name", e.target.value)}
                                          placeholder="Father’s Name"
                                          disabled={isSameDetails && index !== 0}
                                        />
                                        {errors[`child_${index}_father_name`] && (
                                          <div className="error-text">{errors[`child_${index}_father_name`]}</div>
                                        )}
                                      </div>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Father's Contact Number <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.father_contact_no}
                                            onChange={(e) => handleChildChange(index, "father_contact_no", e.target.value)}
                                            placeholder="10-digit number"
                                            maxLength="10"
                                            disabled={
                                              (verificationStatus[index].father_contact.verified && !contactEditMode[index]?.father) ||
                                              (isSameDetails && index !== 0 && sameDetailsOptions[index].sameFatherContact) ||
                                              (isSameDetails && index !== 0)
                                            }
                                          />
                                          {mobileVerificationRequired && !verificationStatus[index].father_contact.verified && (
                                            <button
                                              className="btn btn-outline-primary"
                                              type="button"
                                              onClick={() => sendMobileOTP(index, "father_contact")}
                                              disabled={
                                                !child.father_contact_no ||
                                                !/^\d{10}$/.test(child.father_contact_no) ||
                                                loading
                                              }
                                            >
                                              {mobileVerificationData[index]?.father_contact?.otpSent ? "Resend OTP" : "Send OTP"}
                                            </button>
                                          )}
                                        </div>
                                        {mobileVerificationData[index]?.father_contact?.otpSent && !verificationStatus[index].father_contact.verified && (
                                          <div className="mt-2">
                                            <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control otp-input new_OTP"
                                              placeholder="Enter OTP"
                                              value={mobileOTP[index]?.father_contact || ""}
                                              onChange={(e) => {
                                                const newMobileOTP = [...mobileOTP];
                                                newMobileOTP[index] = {
                                                  ...newMobileOTP[index],
                                                  father_contact: e.target.value
                                                };
                                                setMobileOTP(newMobileOTP);
                                              }}
                                              maxLength="6"
                                            />
                                            <button
                                              className="btn btn-outline-primary new_OTP_button"
                                              type="button"
                                              onClick={() => verifyMobileOTP(index, "father_contact")}
                                              disabled={!mobileOTP[index]?.father_contact || !/^\d{4,6}$/.test(mobileOTP[index]?.father_contact)}
                                            >
                                              Verify OTP
                                            </button>
                                          </div>
                                          </div>
                                        )}
                                        {errors[`child_${index}_father_contact_no`] && (
                                          <div className="error-text">{errors[`child_${index}_father_contact_no`]}</div>
                                        )}
                                        {errors[`child_${index}_father_contact_verification`] && (
                                          <div className="error-text">{errors[`child_${index}_father_contact_verification`]}</div>
                                        )}
                                        {verificationStatus[index].father_contact.verified && (
                                          <div className="verified-text d-flex align-items-center gap-2 mt-2">
                                            <span>
                                              {child.father_contact_no && child.father_contact_no === child.mother_contact_no
                                                ? "Already verified (same as Mother’s contact)"
                                                : "Contact number verified"}
                                            </span>
                                            {!contactEditMode[index]?.father && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-link p-0"
                                                onClick={() => handleContactEdit(index, "father_contact")}
                                              >
                                                Edit
                                              </button>
                                            )}
                                          </div>
                                        )}
                                        {contactEditMode[index]?.father && !verificationStatus[index].father_contact.verified && (
                                          <div className="text-muted small mt-1">
                                            Update the number and resend OTP for verification.
                                          </div>
                                        )}
                                      </div>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Mother’s Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={child.mother_name}
                                          onChange={(e) => handleChildChange(index, "mother_name", e.target.value)}
                                          placeholder="Mother’s Name"
                                          disabled={isSameDetails && index !== 0}
                                        />
                                        {errors[`child_${index}_mother_name`] && (
                                          <div className="error-text">{errors[`child_${index}_mother_name`]}</div>
                                        )}
                                      </div>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Mother’s Contact Number <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.mother_contact_no}
                                            onChange={(e) => handleChildChange(index, "mother_contact_no", e.target.value)}
                                            placeholder="10-digit number"
                                            maxLength="10"
                                            disabled={
                                              (verificationStatus[index].mother_contact.verified && !contactEditMode[index]?.mother) ||
                                              (isSameDetails && index !== 0 && sameDetailsOptions[index].sameMotherContact) ||
                                              (isSameDetails && index !== 0)
                                            }
                                          />
                                          {mobileVerificationRequired && !verificationStatus[index].mother_contact.verified && (
                                            <button
                                              className="btn btn-outline-primary"
                                              type="button"
                                              onClick={() => sendMobileOTP(index, "mother_contact")}
                                              disabled={
                                                !child.mother_contact_no ||
                                                !/^\d{10}$/.test(child.mother_contact_no) ||
                                                loading
                                              }
                                            >
                                              {mobileVerificationData[index]?.mother_contact?.otpSent ? "Resend OTP" : "Send OTP"}
                                            </button>
                                          )}
                                        </div>
                                        {mobileVerificationData[index]?.mother_contact?.otpSent && !verificationStatus[index].mother_contact.verified && (
                                          <div className="mt-2">
                                            <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control otp-input new_OTP"
                                              placeholder="Enter OTP"
                                              value={mobileOTP[index]?.mother_contact || ""}
                                              onChange={(e) => {
                                                const newMobileOTP = [...mobileOTP];
                                                newMobileOTP[index] = {
                                                  ...newMobileOTP[index],
                                                  mother_contact: e.target.value
                                                };
                                                setMobileOTP(newMobileOTP);
                                              }}
                                              maxLength="6"
                                            />
                                            <button
                                              className="btn btn-outline-primary new_OTP_button"
                                              type="button"
                                              onClick={() => verifyMobileOTP(index, "mother_contact")}
                                              disabled={!mobileOTP[index]?.mother_contact || !/^\d{4,6}$/.test(mobileOTP[index]?.mother_contact)}
                                            >
                                              Verify OTP
                                            </button>
                                          </div>
                                          </div>
                                        )}
                                        {errors[`child_${index}_mother_contact_no`] && (
                                          <div className="error-text">{errors[`child_${index}_mother_contact_no`]}</div>
                                        )}
                                        {errors[`child_${index}_mother_contact_no_same`] && (
                                          <div className="error-text">{errors[`child_${index}_mother_contact_no_same`]}</div>
                                        )}
                                        {errors[`child_${index}_mother_contact_verification`] && (
                                          <div className="error-text">{errors[`child_${index}_mother_contact_verification`]}</div>
                                        )}
                                        {verificationStatus[index].mother_contact.verified && (
                                          <div className="verified-text d-flex align-items-center gap-2 mt-2">
                                            <span>
                                              {child.father_contact_no && child.father_contact_no === child.mother_contact_no
                                                ? "Already verified (same as Father’s contact)"
                                                : "Contact number verified"}
                                            </span>
                                            {!contactEditMode[index]?.mother && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-link p-0"
                                                onClick={() => handleContactEdit(index, "mother_contact")}
                                              >
                                                Edit
                                              </button>
                                            )}
                                          </div>
                                        )}
                                        {contactEditMode[index]?.mother && !verificationStatus[index].mother_contact.verified && (
                                          <div className="text-muted small mt-1">
                                            Update the number and resend OTP for verification.
                                          </div>
                                        )}
                                      </div>
                                      {child.father_contact_no === child.mother_contact_no &&
                                        child.father_contact_no &&
                                        child.mother_contact_no &&
                                        sameContactConfirmed[index] && (
                                          <div className="col-md-4">
                                            <label className="form-label">
                                              Reason for Same Contact Number
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.contactReason}
                                              onChange={(e) => handleChildChange(index, "contactReason", e.target.value)}
                                              placeholder="Reason for same contact number"
                                              disabled={isSameDetails && index !== 0}
                                            />
                                          </div>
                                        )}
                                    </>
                                  )}

                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Primary Contact <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={
                                        child.is_single_parent
                                          ? [{ value: child.single_parent, label: child.single_parent.charAt(0).toUpperCase() + child.single_parent.slice(1) }]
                                          : primaryContactOptions
                                      }
                                      value={
                                        child.is_single_parent
                                          ? { value: child.single_parent, label: child.single_parent.charAt(0).toUpperCase() + child.single_parent.slice(1) }
                                          : primaryContactOptions.find((opt) => opt.value === child.primary_contact)
                                      }
                                      onChange={(selectedOption) =>
                                        handleChildChange(index, "primary_contact", selectedOption ? selectedOption.value : "")
                                      }
                                      placeholder="Select Primary Contact"
                                      isDisabled={child.is_single_parent || (isSameDetails && index !== 0)}
                                    />
                                    {errors[`child_${index}_primary_contact`] && (
                                      <div className="error-text">{errors[`child_${index}_primary_contact`]}</div>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Email <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="email"
                                        className="form-control"
                                        value={child.email}
                                        onChange={(e) => handleChildChange(index, "email", e.target.value)}
                                        placeholder="Email"
                                        // disabled={
                                        //   (isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail) ||
                                        //   (isSameDetails && index !== 0)
                                        // }

                                        disabled={
    verificationStatus[index].email.verified || 
    (isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail) ||
    (isSameDetails && index !== 0)
  }

                                      />
                                      
                                      {/* {emailVerificationRequired && (
                                        <button
                                          className="btn btn-outline-primary"
                                          type="button"
                                          onClick={() => sendEmailOTP(index)}
                                          disabled={
                                            verificationStatus[index].email.verified ||
                                            !child.email ||
                                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(child.email) ||
                                            (isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail)
                                          }
                                        >
                                          {verificationStatus[index].email.sent ? "Resend OTP" : "Send OTP"}
                                        </button>
                                      )} */}
                                      {!verificationStatus[index]?.email?.verified && emailVerificationRequired && (
  <button
    className="btn btn-outline-primary"
    type="button"
    onClick={() => sendEmailOTP(index)}
    disabled={
      verificationStatus[index].email.verified ||
      !child.email ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(child.email) ||
      (isSameDetails && index !== 0 && sameDetailsOptions[index].sameEmail) ||
      getOtpCooldown(`email_${index}`) > 0
    }
  >
    {getOtpButtonLabel(`email_${index}`, verificationStatus[index].email.sent)}
  </button>
)}

                                    </div>
                                    {errors[`child_${index}_email`] && (
                                      <div className="error-text">{errors[`child_${index}_email`]}</div>
                                    )}
                                    {errors[`child_${index}_email_same`] && (
                                      <div className="error-text">{errors[`child_${index}_email_same`]}</div>
                                    )}
                                    {errors[`child_${index}_email_verification`] && (
                                      <div className="error-text">{errors[`child_${index}_email_verification`]}</div>
                                    )}
                                    {verificationStatus[index].email.sent && !verificationStatus[index].email.verified && (
                                      <div className="mt-2">
                                        <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control otp-input new_OTP"
                                          placeholder="Enter OTP"
                                          value={verificationStatus[index].email.otp}
                                          onChange={(e) => {
                                            const newVerificationStatus = [...verificationStatus];
                                            newVerificationStatus[index].email.otp = e.target.value;
                                            setVerificationStatus(newVerificationStatus);
                                          }}
                                          maxLength="6"
                                        />
                                        <button
                                          className="btn btn-outline-primary new_OTP_button"
                                          type="button"
                                          onClick={() => verifyEmailOTP(index)}
                                          disabled={!/^\d{6}$/.test(verificationStatus[index].email.otp)}
                                        >
                                          Verify OTP
                                        </button>
                                      </div>
                                      </div>
                                    )}
                                    {verificationStatus[index].email.verified && (
                                      <div className="verified-text">Email verified</div>
                                    )}
                                  </div>
                                </div>
                                <h5>Student Details</h5>
                                <div className="row g-3">
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Full Name (as per Birth Certificate) <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={child.full_name}
                                      onChange={(e) => handleChildChange(index, "full_name", e.target.value)}
                                      placeholder="Full Name"
                                      required
                                    />
                                    {errors[`child_${index}_full_name`] && (
                                      <div className="error-text">{errors[`child_${index}_full_name`]}</div>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Date of Birth (as per Birth Certificate) <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={child.dob}
                                      onChange={(e) => handleChildChange(index, "dob", e.target.value)}
                                      max={new Date().toISOString().split("T")[0]}
                                      required
                                    />
                                    {errors[`child_${index}_dob`] && (
                                      <div className="error-text">{errors[`child_${index}_dob`]}</div>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Gender <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={genderOptions}
                                      value={genderOptions.find((g) => g.value === child.gender)}
                                      onChange={(selectedOption) =>
                                        handleChildChange(index, "gender", selectedOption ? selectedOption.value : "")
                                      }
                                      placeholder="Select Gender"
                                    />
                                    {errors[`child_${index}_gender`] && (
                                      <div className="error-text">{errors[`child_${index}_gender`]}</div>
                                    )}
                                  </div>
                                  <style>{`
                                      .info-icon-btn {
                                        background: none;
                                        border: none;
                                        color: #007bff;
                                        font-size: 16px;
                                        padding: 4px 8px;
                                        cursor: pointer;
                                      }
                                      .info-icon-btn:hover {
                                        color: #0056b3;
                                      }
                                      .info-icon-btn:disabled {
                                        color: #6c757d;
                                        cursor: not-allowed;
                                      }
                                    `}</style>
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Class <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={
                                        child.showAllClasses
                                          ? formattedClasses
                                          : formattedClasses.filter((cls) =>
                                            (child.recommendedClassIds || []).includes(cls.value)
                                          )
                                      }
                                      value={formattedClasses.find((cls) => cls.value === Number(child.class))}
                                      onChange={(selectedOption) =>
                                        handleChildChange(index, "class", selectedOption ? selectedOption.value : "")
                                      }
                                      placeholder="Select Class"
                                      isDisabled={!child.dob}
                                    />
                                    {child.dob && (
                                      <div className="mt-2">
                                        <button
                                          type="button"
                                          className="info-icon-btn"
                                          onClick={() => openClassModal(index)}
                                          title="View age-appropriate classes"
                                        >
                                          <i className="fas fa-info-circle"></i>
                                        </button>
                                      </div>
                                    )}
                                    {/* Updated Age Wise Classes Modal - Only 2 classes in table format without badges */}
                                    {showClassModal && (
                                      <div
                                        className="modal fade show"
                                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                                        tabIndex="-1"
                                        aria-labelledby="classModalLabel"
                                        aria-hidden="true"
                                      >
                                        <div className="modal-dialog modal-md">
                                          <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                              <h6 className="modal-title text-white" id="classModalLabel">
                                                <i className="fas fa-graduation-cap me-2"></i>
                                                <small>Calculated Class Based on Age From</small> {moment(schoolAutomation.enq_dob).format("DD-MM-YYYY")}
                                              </h6>

                                              <button
                                                type="button"
                                                className="btn-close btn-close-white"
                                                onClick={closeClassModal}
                                                aria-label="Close"
                                              ></button>
                                            </div>
                                            <div className="modal-body p-0">
                                              <div className="table-responsive">
                                                <table className="table table-bordered table-hover mb-0">
                                                  <thead className="table-light">
                                                    <tr>
                                                      <th width="60%">Class</th>
                                                      <th width="40%">Age Group</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {/* Show only 2 classes - current selected and one recommended */}
                                                    {(() => {
                                                      const currentChild = childrenData[selectedChildIndex];
                                                      const selectedClass = classes.find(cls => cls.id === Number(currentChild?.class));
                                                      const recommendedClasses = classes.filter(cls =>
                                                        currentChild?.recommendedClassIds?.includes(cls.id)
                                                      );

                                                      // Get first recommended class that's not the currently selected one
                                                      const otherRecommendedClass = recommendedClasses.find(cls =>
                                                        cls.id !== Number(currentChild?.class)
                                                      );

                                                      const classesToShow = [];

                                                      // Add currently selected class
                                                      if (selectedClass) {
                                                        classesToShow.push({
                                                          class: selectedClass,
                                                          isSelected: true,
                                                          isRecommended: currentChild?.recommendedClassIds?.includes(selectedClass.id)
                                                        });
                                                      }

                                                      // Add one other recommended class
                                                      if (otherRecommendedClass) {
                                                        classesToShow.push({
                                                          class: otherRecommendedClass,
                                                          isSelected: false,
                                                          isRecommended: true
                                                        });
                                                      }

                                                      // If no other recommended class, add first available class
                                                      if (classesToShow.length < 2) {
                                                        const firstAvailableClass = classes.find(cls =>
                                                          !classesToShow.some(item => item.class.id === cls.id)
                                                        );
                                                        if (firstAvailableClass) {
                                                          classesToShow.push({
                                                            class: firstAvailableClass,
                                                            isSelected: false,
                                                            isRecommended: currentChild?.recommendedClassIds?.includes(firstAvailableClass.id)
                                                          });
                                                        }
                                                      }

                                                      return classesToShow.map((item, index) => (
                                                        <tr
                                                          key={item.class.id}
                                                          className={`
                                                            ${item.isSelected ? 'table-success' : ''}
                                                            ${item.isRecommended && !item.isSelected ? '' : ''}
                                                            cursor-pointer
                                                          `}
                                                          style={{ cursor: 'pointer' }}
                                                          onClick={() => selectClassFromModal(item.class.id)}
                                                        >
                                                          <td>
                                                            <div className="d-flex align-items-center">
                                                              {item.isSelected && (
                                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                              )}
                                                              {item.class.Classes}
                                                            </div>
                                                          </td>
                                                          <td>
                                                            {item.class.Age_Group} years
                                                          </td>
                                                        </tr>
                                                      ));
                                                    })()}
                                                  </tbody>
                                                </table>
                                              </div>

                                              {/* Additional information */}
                                              <div className="p-3 bg-light border-top">
                                                <div className="row">
                                                  <div className="col-12">
                                                    <small className="text-muted">
                                                      <i className="fas fa-info-circle me-1"></i>
                                                      <strong>Student DOB:</strong> {childrenData[selectedChildIndex]?.dob ?
                                                        moment(childrenData[selectedChildIndex].dob).format("DD-MM-YYYY") : 'Not selected'
                                                      }
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="modal-footer">
                                              <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={closeClassModal}
                                              >
                                                <i className="fas fa-times me-1"></i>
                                                Close
                                              </button>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="form-check mt-2">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={child.showAllClasses}
                                        onChange={(e) => handleShowAllClasses(index, e.target.checked)}
                                        id={`showAllClasses${index}`}
                                      />
                                      <label className="form-check-label" htmlFor={`showAllClasses${index}`}>
                                        See all class options
                                      </label>
                                    </div>
                                    {errors[`child_${index}_class`] && (
                                      <div className="error-text">{errors[`child_${index}_class`]}</div>
                                    )}
                                    {child.classMessage && (
                                      <div className="text-warning mt-1">{child.classMessage}</div>
                                    )}
                                    {child.class && (child.is_bonafide_required === true || !child.matchesAgeCriteria) && (
                                      <>
                                        {selectedClassLabel.match(/^(Nursery|LKG|UKG|I)$/) && (
                                          <div className="text-info mt-1">
                                            Bonafide certificate will be required later. ( Till Class 1)
                                          </div>
                                        )}
                                        {selectedClassLabel.match(/^(II|III|IV|V|VI|VII|VIII|IX|X|XI|XII)$/) && (
                                          <div className="text-info mt-1">
                                            PEN (Permanent Education Number) will be required later. ( Class 2 onwards )
                                          </div>
                                        )}
                                      </>
                                    )}
                                    {/* {child.class && (
                                                                <div className="mt-2">
                                                                    {schoolRules
                                                                        .filter((rule) =>
                                                                            rule.class_section_ids.includes(Number(child.class))
                                                                        )
                                                                        .map((rule) => (
                                                                            <div key={rule.id} className="rule-box">
                                                                                <div className="rule-title">{rule.title}</div>
                                                                                <div className="rule-desc">{rule.description}</div>
                                                                                {rule.is_downloadable && rule.uploadfile && (
                                                                                    <a
                                                                                        href={rule.uploadfile}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="rule-link"
                                                                                    >
                                                                                        Download Rule Document
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            )} */}
                                  </div>
                                  <div className="col-md-4">
                                    {classes.find((cls) => cls.id === Number(child.class))?.streams &&
                                      classes.find((cls) => cls.id === Number(child.class))?.streams.length > 0 &&
                                      !(
                                        classes.find((cls) => cls.id === Number(child.class))?.streams.length === 1 &&
                                        classes.find((cls) => cls.id === Number(child.class))?.streams[0].name === "Default"
                                      ) ? (
                                      <>
                                        <label className="form-label">
                                          Stream {child.stream_id && <span className="text-danger">*</span>}
                                        </label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={classes
                                            .find((cls) => cls.id === Number(child.class))
                                            ?.streams.filter((stream) => stream.name !== "Default")
                                            .map((stream) => ({
                                              value: stream.id,
                                              label: stream.name,
                                            }))}
                                          value={classes
                                            .find((cls) => cls.id === Number(child.class))
                                            ?.streams.find((s) => s.id === Number(child.stream_id))
                                            ? {
                                              value: child.stream_id,
                                              label: classes
                                                .find((cls) => cls.id === Number(child.class))
                                                ?.streams.find((s) => s.id === Number(child.stream_id))?.name,
                                            }
                                            : null}
                                          onChange={(selectedOption) =>
                                            handleChildChange(index, "stream_id", selectedOption ? selectedOption.value : "")
                                          }
                                          placeholder="Select Stream"
                                          isDisabled={!child.class}
                                        />
                                        {errors[`child_${index}_stream_id`] && (
                                          <div className="error-text">{errors[`child_${index}_stream_id`]}</div>
                                        )}
                                      </>
                                    ) : null}
                                  </div>
                                </div>



                                <h5 className="mt-4">Transport Details</h5>
                                <div className="row g-3">
                                  <div className="col-md-4">
                                    <label className="form-label">
                                      Transport Required <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={transportOptions}
                                      value={transportOptions.find((opt) => opt.value === child.transport)}
                                      onChange={(selectedOption) =>
                                        handleChildChange(index, "transport", selectedOption ? selectedOption.value : "No")
                                      }
                                      placeholder="Select Transport"
                                      isDisabled={isSameDetails && index !== 0}
                                    />
                                    {errors[`child_${index}_transport`] && (
                                      <div className="error-text">{errors[`child_${index}_transport`]}</div>
                                    )}
                                  </div>
                                  {child.transport === "Yes" && (
                                    <>
                                      <div className="col-md-4">
                                        <label className="form-label">
                                          Stoppage <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={formattedStoppages}
                                          value={formattedStoppages.find((stop) => stop.value === Number(child.stoppage_id))}
                                          onChange={(selectedOption) =>
                                            handleChildChange(index, "stoppage_id", selectedOption ? selectedOption.value : "")
                                          }
                                          placeholder="Select Stoppage"
                                          isDisabled={isSameDetails && index !== 0}
                                        />
                                        {errors[`child_${index}_stoppage_id`] && (
                                          <div className="error-text">{errors[`child_${index}_stoppage_id`]}</div>
                                        )}
                                      </div>

                                      {/* Display Transport Fees */}
                                      {child.stoppage_id && transportFees[index] && (
                                        <div className="col-md-12 mt-3">
                                          <div className="card">
                                            <div className="card-header bg-light">
                                              <h6 className="mb-0">Transport Fee Details</h6>
                                            </div>
                                            <div className="card-body">
                                              <div className="row">

                                                <div className="col-md-6">
                                                  {/* <h6>Two Way Transport</h6> */}
                                                  <p className="mb-1">Monthly: ₹{transportFees[index].two_way_monthly}</p>
                                                  <p className="mb-0">Annual (12 months): ₹{transportFees[index].two_way_annual}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div className="form-check mt-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={hasFamilyMembers}
                                    onChange={(e) => setHasFamilyMembers(e.target.checked)}
                                    id={`hasFamilyMembers${index}`}
                                    disabled={isSameDetails && index !== 0}
                                  />
                                  <label className="form-check-label" htmlFor={`hasFamilyMembers${index}`}>
                                    Are you previously associated with the school? (Alumni/Staff/Ex-Staff/Cousin of a Student/Other)
                                  </label>
                                </div>

                                {hasFamilyMembers && (index === 0 || !isSameDetails) && (
                                  <>
                                    <h5 className="mt-4">Associated member detail</h5>
                                    <div className="row g-3">
                                      <div className="col-md-4">
                                        <label className="form-label">

                                          How many family members are linked to the school — current or former? <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          classNamePrefix="react-select"
                                          options={familyMemberCountOptions}
                                          value={familyMemberCountOptions.find((opt) => opt.value === familyMemberCount)}
                                          onChange={handleFamilyMemberCountChange}
                                          placeholder="Select Number"
                                        />
                                      </div>
                                    </div>
                                    {familyMembersData.map((member, memberIndex) => {
                                      const role = member.ref_role;
                                      const isCousinOrOther = role === "cousin" || role === "other";
                                      const showCurrentlyWorkingField = role && !["ex_student", "ex_staff", "cousin", "other"].includes(role);
                                      const showAdmissionNumber = ["student", "ex_student"].includes(role);
                                      const showEmployeeCode = ["staff", "ex_staff"].includes(role);
                                      const showYearOfLeaving = role === "ex_student" || role === "ex_staff" || member.ref_is_current === false;
                                      const nameLabel = isCousinOrOther ? "Name" : "Student/Staff Name";

                                      return (
                                        <div key={memberIndex} className="border p-3 mt-3 rounded">
                                          <h6>Associated Member {memberIndex + 1}</h6>
                                          <div className="row g-3">

                                            {/* Role */}
                                            <div className="col-md-4">
                                              <label className="form-label">
                                                Role / Association with School <span className="text-danger">*</span>
                                              </label>
                                              <Select
                                                classNamePrefix="react-select"
                                                options={referenceRoleOptions}
                                                value={referenceRoleOptions.find(
                                                  (opt) => opt.value === member.ref_role
                                                )}
                                                onChange={(selectedOption) =>
                                                  handleFamilyMemberChange(
                                                    memberIndex,
                                                    "ref_role",
                                                    selectedOption ? selectedOption.value : ""
                                                  )
                                                }
                                                placeholder="Select Role"
                                              />
                                              {errors[`family_member_${memberIndex}_ref_role`] && (
                                                <div className="error-text">
                                                  {errors[`family_member_${memberIndex}_ref_role`]}
                                                </div>
                                              )}
                                            </div>

                                            {/* Name */}
                                            <div className="col-md-4">
                                              <label className="form-label">
                                                Associated Member Name <span className="text-danger">*</span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={member.ref_name}
                                                onChange={(e) =>
                                                  handleFamilyMemberChange(memberIndex, "ref_name", e.target.value)
                                                }
                                                placeholder="Enter Name"
                                              />
                                              {errors[`family_member_${memberIndex}_ref_name`] && (
                                                <div className="error-text">
                                                  {errors[`family_member_${memberIndex}_ref_name`]}
                                                </div>
                                              )}
                                            </div>

                                            {/* Relation */}
                                            <div className="col-md-4">
                                              <label className="form-label">
                                                Member's Relation with the Child (Seeking Admission)
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={member.ref_relation}
                                                onChange={(e) =>
                                                  handleFamilyMemberChange(memberIndex, "ref_relation", e.target.value)
                                                }
                                                placeholder="e.g., Sibling, Parent"
                                              />
                                              {errors[`family_member_${memberIndex}_ref_relation`] && (
                                                <div className="error-text">
                                                  {errors[`family_member_${memberIndex}_ref_relation`]}
                                                </div>
                                              )}
                                            </div>

                                            {/* Mobile No */}
                                            <div className="col-md-4">
                                              <label className="form-label">
                                                Associated Contact No. <span className="text-danger"></span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={member.ref_contact_no}
                                                onChange={(e) =>
                                                  handleFamilyMemberChange(memberIndex, "ref_contact_no", e.target.value)
                                                }
                                                placeholder="10-digit number"
                                                maxLength="10"
                                              />
                                              {errors[`family_member_${memberIndex}_ref_contact_no`] && (
                                                <div className="error-text">
                                                  {errors[`family_member_${memberIndex}_ref_contact_no`]}
                                                </div>
                                              )}
                                            </div>

                                            {/* Note */}
                                            <div className="col-md-4">
                                              <label className="form-label">Note - Any other Information</label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={member.ref_note}
                                                onChange={(e) =>
                                                  handleFamilyMemberChange(memberIndex, "ref_note", e.target.value)
                                                }
                                                placeholder="Optional note"
                                              />
                                            </div>

                                          </div>
                                        </div>

                                      );
                                    })}
                                  </>
                                )}
                              </div>
                            </div>
                            </div>
                          );
                        })}

                        <div className="accordion" id="admissionAccordion"> </div>
                        {getChildEnquiryTexts().map((item) => (
                          <div key={item.index} className="enquiry_data_div_1">
                            <h3>
                              {childrenData.length > 1
                                ? `Child ${item.index + 1}${item.childName ? ` (${item.childName})` : ""} - ${item.className}`
                                : item.className}
                            </h3>
                            <p style={{ whiteSpace: "pre-line" }}>{item.text}</p>
                          </div>
                        ))}
                        <div
                          className="enquiry_data_div_1"
                          style={{
                            background: "#fff8e1",
                            border: "1px solid #ffc107",
                            borderLeft: "5px solid #ffc107",
                            borderRadius: "6px",
                            padding: "12px 16px",
                          }}
                        >
                          <h3 style={{ color: "#b45309" }}>Note</h3>
                          {ENQUIRY_NOTES.map((lines, i) => (
                            <ul key={i} className="mb-2">
                              {lines.map((line, j) => (
                                <li key={j}>{line}</li>
                              ))}
                            </ul>
                          ))}
                        </div>




                        <div className="d-flex justify-content-end mt-4">
                          <button
                            type="primary"
                            htmlType="submit"
                            disabled={loading}
                            loading={loading}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            onClick={printEnquiryForm}
                            disabled={loading}
                            className="btn btn-outline-primary me-2"
                          >
                            Print Form
                          </button>
                        </div>
                      </div>
                    </form>

                    {showStudentModal && studentDetails && (
                      <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        tabIndex="-1"
                        aria-labelledby="studentModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="studentModalLabel">
                                Student Details
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowStudentModal(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              {studentDetails.photo_url && (
                                <img
                                  src={studentDetails.photo_url}
                                  alt="Student"
                                  className="student-modal-img"
                                />
                              )}
                              <p>
                                <strong>Student Name:</strong> {studentDetails.student_full_name}
                              </p>
                              <p>
                                <strong>Father’s Name:</strong> {studentDetails.father_full_name}
                              </p>
                              <p>
                                <strong>Mother’s Name:</strong> {studentDetails.mother_full_name}
                              </p>
                              <p>
                                <strong>Father’s Contact:</strong> {studentDetails.father_mobile_no}
                              </p>
                              <p>
                                <strong>Mother’s Contact:</strong> {studentDetails.mother_mobile_no}
                              </p>
                              <p>
                                <strong>Email:</strong> {studentDetails.father_email}
                              </p>
                              <p>
                                <strong>Class:</strong> {studentDetails.class_name} -{" "}
                                {studentDetails.section_name}
                              </p>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={() => setShowStudentModal(false)}
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleConfirmStudentDetails}
                              >
                                Confirm and Autofill
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {existingEnquiryModal.visible && existingEnquiryModal.enquiry && (
                      <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        tabIndex="-1"
                        aria-labelledby="existingEnquiryModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="existingEnquiryModalLabel">
                                Existing Enquiry Details
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={closeExistingEnquiryModal}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <p><strong>Student Name:</strong> {existingEnquiryModal.enquiry.student_full_name || existingEnquiryModal.enquiry.student_name || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Gender:</strong> {existingEnquiryModal.enquiry.gender || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Date of Birth:</strong> {existingEnquiryModal.enquiry.dob || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Class:</strong> {existingEnquiryModal.enquiry.class_data?.Classes || existingEnquiryModal.enquiry.class || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Father's Name:</strong> {existingEnquiryModal.enquiry.fathername || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Mother's Name:</strong> {existingEnquiryModal.enquiry.mothername || "N/A"}</p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <strong>Primary Contact:</strong> {existingEnquiryModal.contactNo}
                                    {" "}
                                    ({existingEnquiryModal.contactLabel
                                      ? existingEnquiryModal.contactLabel.charAt(0).toUpperCase() + existingEnquiryModal.contactLabel.slice(1)
                                      : "Primary"})
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p><strong>Email:</strong> {existingEnquiryModal.enquiry.emailid || "N/A"}</p>
                                </div>
                         

                                <div className="col-md-12">
                                  <p><strong>Enquiry Date:</strong> {existingEnquiryModal.enquiry.enquirydatetime ? moment(existingEnquiryModal.enquiry.enquirydatetime).format("DD-MM-YYYY HH:mm") : "N/A"}</p>
                                </div>
                                <div className="col-md-12">
                                  {existingEnquiryModal.isRegistered ? (
                                    <p className="mb-0 text-muted">
                                      This enquiry is already registered. Details are shown for associated and cannot be auto-filled.
                                    </p>
                                  ) : (
                                    <p className="mb-0 text-muted">
                                      Confirm to auto-fill Child {(existingEnquiryModal.childIndex ?? 0) + 1}'s details with this enquiry.
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={closeExistingEnquiryModal}
                              >
                                Close
                              </button>
                              {!existingEnquiryModal.isRegistered && (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={handleExistingEnquiryApply}
                                >
                                  Confirm and Autofill
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </>
      </div>
    </div>
  )
};
export default CreateEnquiry;